/**
 * Polski.
 *
 * Klucze pochodzą z `cs.js`. Jeśli któregoś brakuje, pojawia się tekst
 * angielski (a w ostateczności czeski), żeby luka rzucała się w oczy.
 *
 * Tego tłumaczenia nie czytała jeszcze żadna osoba trans mówiąca po polsku.
 * Formy inkluzywne (podkreślnik) i słownictwo tranzycji trzeba potwierdzić —
 * jeśli coś brzmi źle, daj znać, a zmienimy.
 */
import { tvary } from '../lib/mnozne';

const pl = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': 'Wróć',
  'obecne.hledat': 'Szukaj',
  'obecne.nacitani': 'Wczytywanie…',
  'obecne.zrusit': 'Anuluj',
  'obecne.ulozit': 'Zapisz',
  'obecne.odeslat': 'Wyślij',
  'obecne.vice': 'Pokaż wszystko',
  'obecne.jazyk': 'Język',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'Bezpieczna przestrzeń dla społeczności trans, gdzie możesz mówić otwarcie, szukać pomocy i czuć wsparcie innych osób.',
  'auth.prihlaseni': 'Zaloguj się',
  'auth.registrace': 'Załóż konto',
  'auth.email': 'E-mail',
  'auth.heslo': 'Hasło',
  'auth.emailPriklad': 'ty@przyklad.pl',
  'auth.prihlasitSe': 'Zaloguj się',
  'auth.prihlasuji': 'Logowanie…',
  'auth.zapomenuteHeslo': 'Nie pamiętasz hasła?',
  'auth.presGoogle': 'Zaloguj się przez Google',
  'auth.spatneUdaje': 'Zły e-mail albo hasło',
  'auth.uspech': 'Zalogowano.',
  'auth.googleChyba': 'Logowanie przez Google się nie udało',
  'auth.obnoveniHesla': 'Reset hasła',
  'auth.obnoveniOdeslano': 'Jeśli ten e-mail jest zarejestrowany, dostaniesz link do zresetowania hasła.',
  'auth.zpetNaPrihlaseni': 'Wróć do logowania',
  'auth.odeslatOdkaz': 'Wyślij link',
  'auth.obnoveniChyba': 'Nie udało się wysłać e-maila. Spróbuj jeszcze raz.',

  // druhý krok přihlášení
  'auth.jesteKod': 'Jeszcze jeden krok: twój kod',
  'auth.jesteKodPopis': 'Otwórz aplikację uwierzytelniającą i przepisz sześć cyfr, które pokazuje dla Bloom.',
  'auth.kod': 'Kod',
  'auth.zalozniKodNapoveda': 'Nie masz telefonu pod ręką? Wpisz jeden z kodów zapasowych, które zapisałaś przy włączaniu.',
  'auth.potvrdit': 'Potwierdź',
  'auth.overuji': 'Sprawdzam…',
  'auth.kodNesedi': 'Ten kod się nie zgadza',
  'auth.zalozniDochazeji': (p) => `Zostało ci już tylko ${p.pocet} kodów zapasowych. Wygeneruj nowe w profilu.`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Jak zainstalować Bloom na telefonie',
  'auth.krokyAndroid': [
      'Otwórz tę stronę w Chrome',
      'Dotknij ikony trzech kropek (⋮) w prawym górnym rogu',
      'Wybierz „Dodaj do ekranu głównego” albo „Zainstaluj aplikację”',
      'Potwierdź instalację',
    ],
  'auth.krokyIos': [
      'Otwórz tę stronę w Safari',
      'Dotknij ikony udostępniania (□↑) na dolnym pasku',
      'Zjedź niżej i wybierz „Do ekranu początkowego”',
      'Potwierdź, dotykając „Dodaj”',
    ],
  'auth.seznamChranene': [
      { silne: 'Nic o osobach z Bloom nie jest publiczne.', text: 'Profile, historie, oferty, pytania, zdjęcia i awatary widzą tylko osoby zalogowane. Nic z tego nie da się pobrać ani zebrać bez konta.' },
      { silne: 'Nikt nie zna twojego hasła', text: '— my też nie. Zapisywany jest skrót bcrypt, z którego nie da się odzyskać oryginału.' },
      { silne: 'Wiadomości prywatne i załączniki są zaszyfrowane', text: '(AES + kontrola spójności) już na dysku serwera. Kto zdobyłby kopię zapasową albo dysk, przeczytałby tylko bezsensowne znaki.' },
      { silne: 'Wiadomości kasują się same', text: 'po jakimś czasie (domyślnie 90 dni), razem z wiadomościami głosowymi i zdjęciami. To, czego tu nie ma, nie wycieknie.' },
      { silne: 'Twój etap tranzycji jest prywatny', text: 'dopóki sama go nie opublikujesz. Kroki odhaczone w Przewodniku widzisz tylko ty.' },
      { silne: 'E-mail i telefon', text: 'nigdy nie są pokazywane innym osobom.' },
      { silne: '', text: 'Logowanie jest chronione przed zgadywaniem hasła: liczba prób jest ograniczona.' },
      { silne: 'Szyfrowanie wiadomości od końca do końca.', text: 'Gdy je włączysz, tekst i załączniki są szyfrowane w twojej własnej przeglądarce, a serwer dostaje tylko nieczytelne znaki. Klucz otwiera się twoim hasłem i nigdy nie opuszcza twojego urządzenia — dlatego my też nie odczytamy treści, nawet gdyby poprosił o to sąd. Cena jest taka, że jeśli zapomnisz hasła, ty też nie przeczytasz starych wiadomości.' },
      { silne: '', text: 'Zalogowanie nie trwa w nieskończoność: Bloom wylogowuje cię przy zamknięciu okna i po dziesięciu minutach bezczynności.' },
    ],
  'auth.seznamNeumime': [
      { silne: 'Metadane', text: '— kto do kogo i kiedy napisał — serwer musi znać, żeby dostarczyć wiadomość. Szyfrowanie od końca do końca tego nie ukrywa, Signal też nie.' },
      { silne: '', text: 'Bloom jest aplikacją internetową, więc przy każdym otwarciu pobiera kod szyfrujący z naszego serwera. Kto przejąłby serwer, mógłby teoretycznie podsunąć zmieniony kod. Chroni przed tym tylko podpisana aplikacja ze sklepu — dlatego Signal ją ma, a wersja przeglądarkowa nie.' },
      { silne: 'Profili', text: '— pseudonim, opis, awatar — nie da się zaszyfrować, bo serwer musi je pokazać innym.' },
      { silne: '', text: 'Wiadomości sprzed włączenia szyfrowania zostają zaszyfrowane tylko na dysku serwera, nie od końca do końca.' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom działa jak aplikacja, nawet bez internetu. Twoje dane są zawsze aktualne.',
  'auth.zabezpeceniTitulek': 'Jak Bloom jest zabezpieczony',
  'auth.zabezpeceniUvod': 'Bloom to przestrzeń dla społeczności trans, więc spotykają się tu rzeczy wrażliwe. Niżej jest to, co '
      + 'robimy, żeby je chronić — i czego nie potrafimy — bez upiększania.',
  'auth.coJeChranene': 'Co jest chronione',
  'auth.coNeumime': 'Czego Bloom nie potrafi — i uczciwie o tym mówimy',
  'auth.zabezpeceniZaver': 'Jeśli masz pytanie o prywatność albo znalazłaś lukę, użyj niżej „Zgłoś problem”. Traktujemy to poważnie.',
  'auth.mvp': 'Bloom jest w pierwszej wersji i poprawiamy go razem ze społecznością. '
      + 'Jeśli trafisz na błąd albo masz pomysł, chętnie się dowiemy.',
  'auth.nahlasitProblem': 'Zgłoś problem',
  'auth.clenu': (p) => tvary('pl', p.pocet, { one: 'osoba', few: 'osoby', many: 'osób', other: 'osób' }),
  'auth.prispevku': (p) => tvary('pl', p.pocet, { one: 'wpis', few: 'wpisy', many: 'wpisów', other: 'wpisów' }),
  'auth.odborniku': (p) => tvary('pl', p.pocet, { one: 'specjalist_ka', few: 'specjalist_ki', many: 'specjalist_ek', other: 'specjalist_ek' }),
  'auth.nabidek': (p) => tvary('pl', p.pocet, { one: 'oferta', few: 'oferty', many: 'ofert', other: 'ofert' }),

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'Pseudonim (niepowtarzalny)',
  'reg.prezdivkaPriklad': 'Co najmniej 3 znaki',
  'reg.telefon': 'Telefon',
  'reg.volitelne': '(opcjonalnie)',
  'reg.heslo': 'Hasło',
  'reg.hesloZnovu': 'Powtórz hasło',
  'reg.zajmeno': 'Zaimki',
  'reg.oMne': 'O mnie',
  'reg.oMnePriklad': 'Kilka słów o tobie…',
  'reg.registrovat': 'Załóż konto',
  'reg.registruji': 'Zakładam konto…',
  'reg.presGoogle': 'Zarejestruj się przez Google',
  'reg.avatar': 'Awatar',
  'reg.neboFoto': 'Albo wgraj własne zdjęcie',
  'reg.nahratFoto': 'Wgraj zdjęcie',
  'reg.vlastni': 'Własne',
  'reg.zeme': 'Kraj',
  'reg.kraj': 'Region',
  'reg.nechciUvadet': 'Wolę nie podawać',
  'reg.cesko': 'Czechy',
  'reg.svet': 'Reszta świata',

  // skupiny avatarů
  'reg.avatarFem': 'Kobiece',
  'reg.avatarMask': 'Męskie',
  'reg.avatarNeutr': 'Neutralne',
  'reg.avatarZvirata': 'Zwierzęta',

  // komunitní heslo
  'reg.komunitniHeslo': 'Hasło społeczności',
  'reg.komunitniHesloPriklad': 'Wpisz hasło społeczności…',
  'reg.komunitniHesloPopis': 'Bloom to prywatna przestrzeń dla społeczności trans. Ktoś ze społeczności może dać ci hasło.',
  'reg.napisAdminovi': 'Jeśli nikogo nie znasz, napisz do administracji na',
  'reg.nevimHeslo': 'Nie znam hasła społeczności',
  'reg.jakZiskat': 'Hasło społeczności chroni tę prywatną przestrzeń. Jak je zdobyć:',
  'reg.krok1': '1. Napisz e-mail na',
  'reg.krok2': '2. Przedstaw się krótko i powiedz, skąd wiesz o Bloom',
  'reg.krok3': '3. Administracja odpowie tak szybko, jak się da',

  // kontrola hesla
  'reg.hesloKratke': 'Hasło musi mieć co najmniej 8 znaków',
  'reg.hesloMale': 'Hasło musi zawierać małą literę',
  'reg.hesloVelke': 'Hasło musi zawierać wielką literę',
  'reg.hesloCislo': 'Hasło musi zawierać cyfrę',
  'reg.hesloZnak': 'Hasło musi zawierać znak specjalny (!@#$%…)',
  'reg.pozadavek8': 'Co najmniej 8 znaków',
  'reg.pozadavekVelke': 'Wielka litera',
  'reg.pozadavekCislo': 'Cyfra',
  'reg.pozadavekZnak': 'Znak specjalny (!@#$%)',
  'reg.hesloNesouhlasi': 'Hasła nie są takie same',
  'reg.prezdivkaKratka': 'Pseudonim musi mieć co najmniej 3 znaki',
  'reg.hesloPovinne': 'Hasło społeczności jest wymagane',
  'reg.hotovo': 'Konto założone. Sprawdź e-mail, żeby je potwierdzić.',
  'reg.fotoVelka': 'Zdjęcie jest za duże (maks. 2 MB)',
  'reg.chyba': 'Nie udało się założyć konta',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'Nikt tu nie musi być idealny. Bloom to przestrzeń, w której każda osoba może być sobą — '
      + 'gdzie możesz dzielić się doświadczeniem, pytać i pomagać innym. Bez oceniania i bez uprzedzeń.',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · przetłumaczone z czeskiego',
  'domu.vitej': 'Cześć,',
  'domu.vCislech': 'Bloom w liczbach',
  'domu.noveVKomunite': 'Jesteś tu pierwszy raz?',
  'domu.noveVKomunitePopis1': 'Nie musisz być widoczna. Nie potrzebujesz zdjęcia. Nie musisz być out.',
  'domu.noveVKomunitePopis2': 'Bloom to przestrzeń, w której możesz zacząć w swoim tempie.',
  'domu.rozcestnik1': 'Jestem tu pierwszy raz',
  'domu.rozcestnik2': 'Nie wiem, od czego zacząć',
  'domu.rozcestnik3': 'Chcę zostać anonimowa',
  'domu.rozcestnik4': 'Szukam specjalist_ki',
  'domu.rozcestnik5': 'Chcę tylko poczytać doświadczenia',
  'domu.otazky': 'Masz pytania albo chcesz wiedzieć więcej? Napisz do nas na',
  'domu.doporucujeme': 'Polecamy',
  'domu.odbornici': 'Specjalist_ki',
  'domu.noviClenove': 'Nowe osoby w społeczności',
  'domu.zadniNovi': 'Na razie nikogo nowego',
  'domu.nejnovejsiOtazky': 'Najnowsze pytania',
  'domu.zadneOtazky': 'Na razie nie ma pytań.',
  'domu.nejlepeHodnoceni': 'Najlepiej oceniane specjalist_ki',
  'domu.zadniHodnoceni': 'Na razie nie ma ocen',
  'domu.zadneAktuality': 'Na razie nie ma aktualności',

  // dlaždice sekcí
  'domu.dlazdice.support': 'Zaproponuj to, co umiesz, i przyjmij pomoc od innych.',
  'domu.dlazdice.specialists': 'Znajdź sprawdzone specjalist_ki, od psychologii po chirurgię plastyczną.',
  'domu.dlazdice.legal': 'Pomoc prawna, artykuły i odpowiedzi na twoje pytania.',
  'domu.dlazdice.nearby': 'Usługi i specjalist_ki w twojej okolicy.',

  // počty
  'domu.pocetClenu': (p) => tvary('pl', p.pocet, { one: 'osoba w społeczności', few: 'osoby w społeczności', many: 'osób w społeczności', other: 'osób w społeczności' }),
  'domu.pocetZkusenosti': (p) => tvary('pl', p.pocet, { one: 'opisane doświadczenie', few: 'opisane doświadczenia', many: 'opisanych doświadczeń', other: 'opisanych doświadczeń' }),
  'domu.pocetOdborniku': (p) => tvary('pl', p.pocet, { one: 'sprawdzona specjalist_ka', few: 'sprawdzone specjalist_ki', many: 'sprawdzonych specjalist_ek', other: 'sprawdzonych specjalist_ek' }),
  'domu.pocetNabidek': (p) => tvary('pl', p.pocet, { one: 'oferta wsparcia', few: 'oferty wsparcia', many: 'ofert wsparcia', other: 'ofert wsparcia' }),

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'Start',
  'nav.news': 'Aktualności',
  'nav.stories': 'Doświadczenia społeczności',
  'nav.mapaSveta': 'Mapa świata',
  'nav.support': 'Wzajemna pomoc',
  'nav.specialists': 'Trans-friendly specjalist_ki',
  'nav.legal': 'Pomoc prawna',
  'nav.pageants': 'Konkursy',
  'nav.nearby': 'W mojej okolicy',
  'nav.hledat': 'Szukaj w Bloom',
  'nav.hledatPlaceholder': 'Szukaj osób, specjalist_ek, artykułów…',
  'nav.zpravy': 'Wiadomości',
  'nav.profil': 'Mój profil',
  'nav.mojeCesta': 'Moja droga',
  'nav.administrace': 'Administracja',
  'nav.odhlasit': 'Wyloguj się',
  'nav.vsechnyVysledky': (p) => `Pokaż wszystkie wyniki dla „${p.dotaz}”`,
  'nav.overEmail': 'Potwierdź swój e-mail',
  'nav.menu': 'Menu',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': 'Bloom na świecie',
  'svet.podtitulek': 'Wybierz kraj i zobacz, co społeczność tam zebrała.',
  'svet.hledatZemi': 'Szukaj kraju…',
  'svet.vsechnyZeme': 'Wszystkie kraje',
  'svet.jenSObsahem': 'Tylko kraje z treścią',
  'svet.nicNenalezeno': 'Żaden kraj nie pasuje.',
  'svet.zaznamu': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'wpis', few: 'wpisy', many: 'wpisów', other: 'wpisów' })}`,
  'svet.prazdnaZeme': 'Na razie nic',
  'svet.kontinent': 'Kontynent',
  'svet.celySvet': 'Cały świat',
  'svet.vse': 'Wszystko',
  'svet.zacniDomovem': 'Zacznij od wybrania kraju, w którym mieszkasz. Możesz go też wybrać z listy pod mapą.',
  'svet.zkoumej': 'Wybierz kraj i zobacz, co Bloom tam ma. Możesz przeglądać, gdzie chcesz — '
      + 'twój kraj się przez to nie zmieni.',
  'svet.domov': 'Dom',
  'svet.zrusitDomov': 'Usuń kraj zamieszkania',
  'svet.nastavitDomov': 'Ustaw jako mój kraj',
  'svet.zeSveta': 'Ze świata',
  'svet.coSeChysta': 'Co się szykuje',
  'svet.souteze': 'Konkursy z otwartymi zgłoszeniami',
  'svet.noveOrganizace': 'Nowe organizacje',
  'svet.kdeJizNeco': 'Gdzie Bloom już coś ma',
  'svet.hledatZemiPopisek': 'Szukaj kraju',
  'svet.nicNeodpovida': 'Nic nie pasuje. Spróbuj inaczej.',
  'svet.napovedaKMape': 'Przeciągnij mapę, żeby ją przesunąć, i przybliż kółkiem albo przyciskami. Nie musisz '
      + 'z niej korzystać — niżej są wyszukiwarka i pełna lista krajów.',
  'svet.tvujBloom': (p) => `Twój Bloom w kraju ${p.zeme}`,
  'svet.tvojeDomovska': 'twój kraj zamieszkania',
  'svet.zemi': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'kraj', few: 'kraje', many: 'krajów', other: 'krajów' })}`,
  'svet.chyba': 'Nie udało się wczytać krajów. Odśwież stronę.',
  'svet.pocet.specialists': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'specjalist_ka', few: 'specjalist_ki', many: 'specjalist_ek', other: 'specjalist_ek' })}`,
  'svet.pocet.organizations': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'organizacja', few: 'organizacje', many: 'organizacji', other: 'organizacji' })}`,
  'svet.pocet.events': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'wydarzenie', few: 'wydarzenia', many: 'wydarzeń', other: 'wydarzeń' })}`,
  'svet.pocet.pageants': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'konkurs', few: 'konkursy', many: 'konkursów', other: 'konkursów' })}`,
  'svet.pocet.resources': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'materiał', few: 'materiały', many: 'materiałów', other: 'materiałów' })}`,

  // světadíly
  'kontinent.europe': 'Europa',
  'kontinent.asia': 'Azja',
  'kontinent.africa': 'Afryka',
  'kontinent.north_america': 'Ameryka Północna',
  'kontinent.south_america': 'Ameryka Południowa',
  'kontinent.oceania': 'Oceania',
  'kontinent.antarctica': 'Antarktyda',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': 'Konkursy trans z całego świata. Te, do których wciąż możesz się zgłosić, są na górze.',
  'souteze.hledat': 'Szukaj konkursu…',
  'souteze.zadne': 'Nie mamy jeszcze konkursów. Znasz jakiś? Wyślij propozycję.',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `Otwórz: ${p.zeme}`,
  'nahled.zavrit': 'Zamknij podgląd',
  'nahled.jenInformace': 'Na razie mamy tylko informacje o kraju.',
  'nahled.zatimNic': 'Nie mamy tu jeszcze kontaktów, organizacji ani wydarzeń. Coś znasz? Wyślij propozycję.',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `Bloom: ${p.zeme}`,
  'zeme.podtitulek': (p) => `Co społeczność zebrała w kraju ${p.zeme}.`,
  'zeme.prazdna': 'Bloom dopiero tu zaczyna. Możesz być pierwszą osobą, która coś doda.',
  'zeme.mapaSveta': 'Mapa świata',
  'zeme.navrhnout': 'Zaproponuj wpis',
  'zeme.domovska': 'Twój kraj zamieszkania',
  'zeme.nastavitDomovskou': 'Ustaw jako mój kraj',
  'zeme.kdeToJe': 'Gdzie to znaleźć',
  'zeme.coTuBude': 'Co tu znajdziesz',
  'zeme.zatimPrazdne': 'na razie pusto',
  'zeme.pripravujeme': 'w przygotowaniu',
  'zeme.zobrazitVse': (p) => `Pokaż wszystko (${p.pocet})`,
  'zeme.rosteTitulek': 'Bloom dopiero tu rośnie',
  'zeme.rostePopis': 'Nie mamy tu jeszcze nic. Znasz organizację, wydarzenie albo przydatny '
      + 'kontakt? Wyślij propozycję — przejdzie przez sprawdzenie i wtedy pojawi się tutaj.',
  'zeme.jinouZemi': 'Przejrzyj inne kraje',
  'zeme.bezKontaktu': 'Nie mamy tu jeszcze kontaktów ani organizacji.',
  'zeme.bezKontaktuPopis': 'Znasz tu kogoś albo coś przydatnego? Wyślij propozycję — przejdzie przez '
      + 'sprawdzenie i wtedy pojawi się tutaj.',
  'zeme.neznama': 'Nie znamy takiego kraju.',
  'zeme.chyba': 'Nie udało się wczytać kraju.',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': 'Gabinety i kliniki',
  'sekce.specialists.popis': 'Lekarki i lekarze, kliniki i inne osoby, z którymi społeczność ma doświadczenie.',
  'sekce.organizations': 'Organizacje',
  'sekce.organizations.popis': 'Stowarzyszenia, fundacje i grupy wsparcia.',
  'sekce.events': 'Wydarzenia',
  'sekce.events.popis': 'Spotkania, Parady Równości, warsztaty i konferencje.',
  'sekce.pageants': 'Konkursy',
  'sekce.pageants.popis': 'Konkursy trans i ich terminy.',
  'sekce.resources': 'Materiały',
  'sekce.resources.popis': 'Praktyczne informacje o tym kraju.',
  'sekce.community': 'Społeczność',
  'sekce.community.popis': 'Osoby i grupy w tym kraju.',
  'sekce.legal': 'Pomoc prawna',
  'sekce.legal.popis': 'Informacje i wsparcie dla społeczności trans',
  'sekce.support': 'Wzajemna pomoc',
  'sekce.support.popis': 'Zaproponuj to, co umiesz, i przyjmij pomoc od innych osób ze społeczności',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'Szukaj w tym kraju…',
  'vypis.vsechnyKategorie': 'Wszystkie kategorie',
  'vypis.kategorie': 'Kategoria',
  'vypis.celaZeme': 'Cały kraj',
  'vypis.navrhnout': 'Zaproponuj',
  'vypis.nicNeodpovida': 'Nic nie pasuje. Spróbuj inaczej albo zdejmij filtr.',
  'vypis.zadneZaznamy': (p) => `Nie mamy jeszcze wpisów w kraju ${p.zeme}.`,
  'vypis.zaznamu': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'wpis', few: 'wpisy', many: 'wpisów', other: 'wpisów' })}`,
  'vypis.predchozi': 'Poprzednia',
  'vypis.dalsi': 'Następna',
  'vypis.chyba': 'Nie udało się wczytać wpisów.',
  'vypis.neznamyDruh': 'Nie znamy takiego rodzaju wpisu.',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `Wróć: ${p.zeme}`,
  'detail.kontakty': 'Kontakt i linki',
  'detail.podrobnosti': 'Szczegóły',
  'detail.zacatek': 'Początek',
  'detail.termin': 'Termin',
  'detail.uzaverka': 'Termin zgłoszeń',
  'detail.prihlaska': 'Zgłoszenie',
  'detail.strankaAkce': 'Strona wydarzenia',
  'detail.web': 'Strona',
  'detail.konec': 'Koniec',
  'detail.stavRocniku': 'Stan edycji',
  'detail.oblasti': 'Obszary działania',
  'detail.coNabizi': 'Co oferują',
  'detail.kategorie': 'Kategorie',
  'detail.jazyky': 'Języki',
  'detail.vitezove': 'Poprzednie zwyciężczynie',
  'detail.kdoSeMuze': 'Kto może się zgłosić',
  'detail.poradatel': 'Organizacja',
  'detail.poplatek': 'Opłata',
  'detail.tema': 'Temat',
  'detail.forma.offline': 'Na miejscu',
  'detail.forma.online': 'Online',
  'detail.forma.hybrid': 'Na miejscu i online',
  'detail.rozsah.local': 'Lokalny',
  'detail.rozsah.national': 'Ogólnokrajowy',
  'detail.rozsah.international': 'Międzynarodowy',
  'detail.rocnik.upcoming': 'Szykuje się',
  'detail.rocnik.registration_open': 'Zgłoszenia otwarte',
  'detail.rocnik.registration_closed': 'Zgłoszenia zamknięte',
  'detail.rocnik.completed': 'Odbyło się',
  'detail.zdroj': (p) => `Źródło: ${p.zdroj}`,
  'detail.upraveno': (p) => `Ostatnia zmiana: ${p.datum}`,
  'detail.overeno': 'Sprawdzone, że wpis odpowiada rzeczywistości. To nie jest rekomendacja Bloom.',
  'detail.neovereno': 'Ten wpis nie jest jeszcze sprawdzony. Dane mogły się zmienić — zweryfikuj u źródła.',
  'detail.nenalezen': 'Nie znamy takiego wpisu. Mógł zostać usunięty albo wciąż czeka na sprawdzenie.',
  'detail.chyba': 'Nie udało się wczytać wpisu.',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'Co tu obowiązuje',
  'profil.name_change': 'Zmiana imienia',
  'profil.gender_marker': 'Zmiana oznaczenia płci',
  'profil.surgery_required': 'Wymagana operacja',
  'profil.healthcare': 'Dostęp do opieki zdrowotnej',
  'profil.legal_protection': 'Ochrona przed dyskryminacją',
  'profil.safety': 'Bezpieczeństwo',
  'profil.stav.yes': 'Tak',
  'profil.stav.limited': 'Częściowo',
  'profil.stav.no': 'Nie',
  'profil.stav.unknown': 'Brak danych',
  'profil.zdroj': 'Źródło',
  'profil.zdrojZRoku': (p) => `źródło z ${p.rok}`,
  'profil.overeno': (p) => `Sprawdzone ${p.datum}`,
  'profil.zmena': 'Ostatnia zmiana',
  'profil.odKdy': (p) => `obowiązuje od ${p.datum}`,
  'profil.doklady': 'Źródła',
  'profil.zakon': 'ustawa albo wyrok',
  'profil.upozorneni': 'To nie jest porada prawna. Prawo się zmienia i wiele zależy od twojej '
      + 'konkretnej sytuacji — sprawdź u źródła albo w organizacji z tego '
      + 'kraju, zanim na tym oprzesz decyzję.',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `Zaproponuj ${p.druh}${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': 'Twoja propozycja przechodzi przez sprawdzenie, zanim pojawi się w Bloom. Wypełnij to, co '
      + 'wiesz — resztę uzupełnimy.',
  'navrh.jednotne.organizations': 'organizację',
  'navrh.jednotne.events': 'wydarzenie',
  'navrh.jednotne.pageants': 'konkurs',
  'navrh.jednotne.resources': 'materiał',
  'navrh.popis.organizations': 'Stowarzyszenie, fundacja albo grupa wsparcia.',
  'navrh.popis.events': 'Spotkanie, Parada Równości, warsztat, konferencja.',
  'navrh.popis.pageants': 'Konkurs trans – termin, zgłoszenia, kto organizuje.',
  'navrh.popis.resources': 'Praktyczna informacja – zdrowie, prawo, dokumenty, kontakty.',
  'navrh.nazev': 'Nazwa',
  'navrh.popisPole': 'Opis',
  'navrh.zeme': 'Kraj',
  'navrh.mesto': 'Miasto',
  'navrh.adresa': 'Adres',
  'navrh.web': 'Strona',
  'navrh.email': 'E-mail',
  'navrh.telefon': 'Telefon',
  'navrh.odkudVis': 'Skąd o tym wiesz',
  'navrh.odkudVisPriklad': 'np. z ich strony, byłam tam…',
  'navrh.vyberte': '— wybierz —',
  'navrh.forma': 'Forma',
  'navrh.rozsah': 'Zasięg',
  'navrh.platiPro': 'Dotyczy',
  'navrh.platnost.global': 'Całego świata',
  'navrh.platnost.country': 'Kraju',
  'navrh.platnost.region': 'Regionu',
  'navrh.platnost.city': 'Miasta',
  'navrh.odkazAkce': 'Link do wydarzenia',
  'navrh.odkazPrihlaska': 'Link do zgłoszenia',
  'navrh.odkazy': 'Linki',
  'navrh.text': 'Tekst',
  'navrh.odeslat': 'Wyślij propozycję',
  'navrh.odesilam': 'Wysyłam…',
  'navrh.chyba': 'Nie udało się wysłać propozycji',
  'navrh.dikyTitulek': 'Dzięki, mamy to',
  'navrh.dikyPopis': 'Dostaliśmy twoją propozycję. Ktoś ją sprawdzi i wtedy pojawi się '
      + 'w Bloom. Nic nie publikuje się automatycznie.',
  'navrh.zavrit': 'Zamknij',
  'navrh.seznamNapoveda': 'Oddzielaj pozycje przecinkami.',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `Czy ${p.druh} należy do ciebie?`,
  'prevzeti.popis': 'Możesz przejąć profil i dbać o aktualność danych. '
      + 'Prośba najpierw przechodzi przez sprawdzenie.',
  'prevzeti.tlacitko': 'Przejmij ten profil',
  'prevzeti.spravujes': 'Zarządzasz tym profilem. Dane możesz poprawiać kiedy chcesz — zmiany działają od razu.',
  'prevzeti.upravit': 'Edytuj dane',
  'prevzeti.spravujeSama': (p) => `Tym profilem zarządza sama ${p.druh}.`,
  'prevzeti.ceka': 'Dostaliśmy twoją prośbę i ją sprawdzamy.',
  'prevzeti.formulacTitulek': (p) => `Przejęcie profilu — ${p.nazev}`,
  'prevzeti.formulacPopis': 'Zanim przekażemy profil, musimy wiedzieć, że naprawdę należysz do tej '
      + 'organizacji. Prośba przechodzi przez sprawdzenie; na razie nic się nie zmienia.',
  'prevzeti.role': 'Jaka jest twoja rola?',
  'prevzeti.rolePriklad': 'np. koordynacja, zarząd stowarzyszenia',
  'prevzeti.doklad': 'Jak możemy to sprawdzić?',
  'prevzeti.dokladPriklad': 'np. jestem na stronie organizacji w kontaktach; albo napisz z oficjalnego adresu',
  'prevzeti.dokladNapoveda': 'Wystarczy link do strony, na której jesteś wymieniona, albo oficjalny '
      + 'adres organizacji, z którego napiszesz.',
  'prevzeti.kontakt': 'Twój kontakt',
  'prevzeti.kontaktPriklad': 'e-mail albo telefon',
  'prevzeti.dalsi': 'Coś jeszcze',
  'prevzeti.nepovinne': '(opcjonalnie)',
  'prevzeti.odeslat': 'Wyślij prośbę',
  'prevzeti.odesilam': 'Wysyłam…',
  'prevzeti.vyplnObe': 'Napisz, jaka jest twoja rola i jak można to sprawdzić.',
  'prevzeti.prijato': 'Dziękujemy. Dostaliśmy twoją prośbę i odezwiemy się.',
  'prevzeti.chyba': 'Nie udało się wysłać prośby.',
  'prevzeti.upravaTitulek': (p) => `Edycja profilu — ${p.nazev}`,
  'prevzeti.upravaPopis': 'Nazwy i miejsca celowo tu nie ma: po nich wpisy się wyszukuje i '
      + 'sortuje. Jeśli się zmieniły, napisz do nas, a je zaktualizujemy.',
  'prevzeti.popisPole': 'Opis',
  'prevzeti.email': 'E-mail',
  'prevzeti.telefon': 'Telefon',
  'prevzeti.web': 'Strona',
  'prevzeti.ulozeno': 'Zapisano.',
  'prevzeti.ukladam': 'Zapisuję…',
  'prevzeti.chybaUlozeni': 'Nie udało się zapisać.',
  'prevzeti.druh.organizations': 'organizacja',
  'prevzeti.druh.events': 'wydarzenie',
  'prevzeti.druh.pageants': 'konkurs',

  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'Edytuj swoje dane i ustawienia',
  'profil.overeny': 'Potwierdzony',
  'profil.neovereny': 'Niepotwierdzony',
  'profil.overteEmail': 'Potwierdź swój e-mail. Niepotwierdzone konto ma ograniczone uprawnienia.',
  'profil.emailOdeslan': 'E-mail potwierdzający wysłany.',
  'profil.emailChyba': 'Nie udało się wysłać e-maila',
  'profil.odeslano': 'Wysłano.',
  'profil.overeniOdbornika': 'Weryfikacja jako specjalist_ka albo prawni_czka',
  'profil.pracujeteVOboru': 'Pracujesz w tej dziedzinie? Zdobądź odznakę weryfikacji.',
  'profil.zadostOdeslana': 'Prośba wysłana',
  'profil.pozadatOOvereni': 'Poproś o weryfikację',
  'profil.zadostTitulek': 'Prośba o weryfikację jako specjalist_ka albo prawni_czka',
  'profil.zadostPopis': 'Wypełnij dane prośby. Moderacja ją sprawdzi.',
  'profil.pozadovanaRole': 'Rola, o którą prosisz',
  'profil.roleOdbornik': 'Specjalist_ka',
  'profil.rolePravnik': 'Prawni_czka',
  'profil.specializace': 'Specjalizacja',
  'profil.odkazNaProfil': 'Link do profilu zawodowego',
  'profil.zpravaProAdmina': 'Krótka wiadomość do administracji',
  'profil.odesilam': 'Wysyłam…',
  'profil.odeslatZadost': 'Wyślij prośbę o weryfikację',
  'profil.vyplnteSpecializaci': 'Wypełnij swoją specjalizację',
  'profil.zadostUspech': 'Twoja prośba o weryfikację została wysłana.',
  'profil.zadostChyba': 'Nie udało się wysłać prośby',

  // bezpečnost
  'bezp.titulek': 'Bezpieczeństwo',
  'bezp.sifrovaniZapnuto': (p) => `Szyfrowanie wiadomości jest włączone${p.odemceno ? ' i odblokowane' : ' (zablokowane w tej karcie)'}.`,
  'bezp.sifrovaniVypnuto': 'Nie masz jeszcze włączonego szyfrowania wiadomości.',
  'bezp.sifrovaniKde': 'Włączasz je i odblokowujesz na stronie Wiadomości.',
  'bezp.sifrovaniKdeVypnute': 'Możesz je włączyć na stronie Wiadomości, w dowolnej rozmowie.',
  'bezp.zmenaHesla': 'Zmiana hasła',
  'bezp.zmenaHeslaSifrovani': 'Masz włączone szyfrowanie, więc zmiana hasła przepakowuje też klucz do twoich wiadomości. '
      + 'Dlatego potrzebne jest obecne hasło — bez niego klucza nie dałoby się otworzyć i straciłabyś wiadomości.',
  'bezp.stavajiciHeslo': 'Obecne hasło',
  'bezp.noveHeslo': 'Nowe hasło',
  'bezp.noveHesloZnovu': 'Powtórz nowe hasło',
  'bezp.pozadavky': 'Co najmniej 8 znaków, wielkie i małe litery, cyfra i znak specjalny.',
  'bezp.zmenitHeslo': 'Zmień hasło',
  'bezp.menim': 'Zmieniam…',
  'bezp.hesloNeshoda': 'Nowe hasła nie są takie same.',
  'bezp.vyplnObe': 'Wypełnij oba hasła.',
  'bezp.stareNesedi': 'Obecne hasło się nie zgadza — klucz do twoich wiadomości by przepadł, więc nic nie zmieniliśmy.',
  'bezp.zmenenoSKlicem': 'Hasło zmienione. Klucz do twoich wiadomości został przepakowany, więc stare wiadomości nadal są czytelne.',
  'bezp.zmeneno': 'Hasło zmienione.',
  'bezp.zmenaChyba': 'Nie udało się zmienić hasła.',
  'bezp.nepamatujes': 'Nie pamiętasz hasła do klucza?',
  'bezp.zahoditPopis': 'Możesz odrzucić klucz i zacząć od nowa. Wiadomości zaszyfrowane do tej pory przepadną na zawsze — '
      + 'nikt ich nie odczyta, my też nie. I właśnie dlatego to jest bezpieczne.',
  'bezp.zahodit': 'Odrzuć klucze i zacznij od nowa',
  'bezp.zahoditPotvrzeni': 'Naprawdę odrzucić klucze?\n\nWszystkie wiadomości zaszyfrowane do tej pory przepadną na zawsze — '
      + 'nikt ich nie odczyta, my też nie. Zrób to tylko wtedy, gdy nie pamiętasz hasła, '
      + 'którego użyłaś przy włączaniu szyfrowania.',
  'bezp.klicSmazan': 'Klucze usunięte. Odśwież stronę.',
  'bezp.nepovedlo': 'Nie udało się.',
  'bezp.prohlizecNeumi': 'Ta przeglądarka nie obsługuje szyfrowania, którego używa Bloom.',

  'profil.mujProfil': 'Mój profil',
  'profil.specializacePriklad': 'np. psychologia, seksuologia, prawo…',
  'profil.zpravaPriklad': 'Na przykład link do wpisu w rejestrze zawodowym albo do strony gabinetu…',
  'profil.overeniUvod': 'Chcesz być w Bloom zweryfikowaną specjalist_ką albo prawni_czką? Wyślij prośbę o weryfikację. '
      + 'Twój profil musi odpowiadać twojemu prawdziwemu zawodowi.',

  'profil.oborPriklad': 'np. chirurgia plastyczna, prawo rodzinne…',
  'profil.nepovinnyText': 'Dodatkowa uwaga, opcjonalnie…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': 'Logowanie dwuetapowe',
  'dvf.zapnuto': (p) => `Włączone. Zostało ci ${p.pocet} kodów zapasowych.`,
  'dvf.vypnuto': 'Oprócz hasła wpisujesz sześciocyfrowy kod z aplikacji na telefonie.',
  'dvf.chraniA': 'Chroni',
  'dvf.chraniPrihlaseni': 'logowanie',
  'dvf.chraniB': ': kto zna twoje hasło, ale nie ma twojego telefonu, nie wejdzie.',
  'dvf.nechrani': 'Nie chroni zaszyfrowanych wiadomości',
  'dvf.nechraniPopis': ' — te otwiera twoje hasło w twojej własnej przeglądarce, bez udziału serwera.',
  'dvf.ulozKody': 'Zapisz te dziesięć kodów zapasowych',
  'dvf.ulozKodyPopis1': 'Każdy działa raz i są jedyną drogą do środka, jeśli zgubisz telefon.',
  'dvf.znovuNeukaze': 'Nikt ci ich już nie pokaże',
  'dvf.ulozKodyPopis2': ' — przechowujemy tylko ich skróty.',
  'dvf.zkopirovat': 'Kopiuj',
  'dvf.ulozilaJsem': 'Zapisałam je',
  'dvf.zkopirovano': 'Skopiowano.',
  'dvf.kopieChyba': 'Kopiowanie się nie udało, przepisz je ręcznie.',
  'dvf.zapnout': 'Włącz logowanie dwuetapowe',
  'dvf.pripravuji': 'Przygotowuję…',
  'dvf.nactiKod': 'Zeskanuj ten kod w aplikacji uwierzytelniającej — na przykład Google Authenticator, Authy, 1Password albo Aegis.',
  'dvf.qrNejde': 'Nie da się zeskanować kodu QR?',
  'dvf.zadejRucne': 'Wpisz ten klucz w aplikacji ręcznie:',
  'dvf.opisKod': 'Przepisz kod, który pokazuje aplikacja',
  'dvf.zapnoutKratce': 'Włącz',
  'dvf.overuji': 'Sprawdzam…',
  'dvf.noveKody': 'Nowe kody zapasowe',
  'dvf.vypnout': 'Wyłącz',
  'dvf.noveKodyPopis': 'Nowy zestaw zastępuje stary — twoje obecne kody zapasowe przestaną działać.',
  'dvf.kodZAplikace': 'Kod z aplikacji',
  'dvf.vygenerovat': 'Wygeneruj',
  'dvf.vypnutiPopis': 'Do wyłączenia potrzebne są twoje hasło i ważny kod. Oba celowo: inaczej ktoś z dostępem do otwartej przeglądarki mógłby to zdjąć.',
  'dvf.kodNeboZalozni': 'Kod z aplikacji albo kod zapasowy',
  'dvf.vypinam': 'Wyłączam…',
  'dvf.vypnoutCele': 'Wyłącz logowanie dwuetapowe',
  'dvf.vypnuto2': 'Logowanie dwuetapowe wyłączone.',
  'dvf.kodNesedi': 'Ten kod się nie zgadza.',
  'dvf.nepovedlo': 'Nie udało się.',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'Profil zaktualizowany.',
  'pf.chyba': 'Nie udało się zaktualizować profilu',
  'pf.fotkaNahrana': 'Zdjęcie wgrane.',
  'pf.fotkaChyba': 'Nie udało się wgrać zdjęcia',
  'pf.fotkaVelka': 'Zdjęcie jest za duże (maks. 5 MB)',
  'pf.oznameniUlozeno': 'Ustawienia powiadomień zapisane.',
  'pf.oznameniChyba': 'Nie udało się zapisać ustawień',
  'pf.zruseno': 'Twój profil został usunięty',
  'pf.zruseniChyba': 'Nie udało się usunąć profilu',
  'pf.zruseniPotvrzeni': 'Na pewno chcesz usunąć swój profil? Tego nie da się cofnąć, a wszystkie twoje dane zostaną skasowane.',
  'pf.urlFacebook': 'Adres Facebooka musi zaczynać się od https://',
  'pf.urlInstagram': 'Adres Instagrama musi zaczynać się od https://',
  'pf.urlLinkedin': 'Adres LinkedIna musi zaczynać się od https://',
  'pf.ukladam': 'Zapisuję…',
  'pf.ulozitOznameni': 'Zapisz ustawienia powiadomień',
  'pf.oznameniZpravy': 'Wiadomości prywatne',
  'pf.oznameniAdmin': 'Nowa wiadomość od administracji',
  'pf.oznameniUzivatel': 'Nowa wiadomość od innej osoby',
  'pf.oznameniPodpora': 'Nowy wpis we Wzajemnej pomocy',
  'pf.oznameniNabidky': 'Oferty i prośby',

  // odznaky
  'pf.odznakAdmin': 'Administracja',
  'pf.odznakPravnik': 'Prawni_czka',
  'pf.odznakSpecialista': 'Zweryfikowana specjalist_ka',
  'pf.odznakClen': 'Zweryfikowana osoba ze społeczności',
  'pf.odznakPomocnik': 'Aktywna pomoc',
  'pf.odznakDuveryhodny': 'Osoba godna zaufania',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': 'Zdjęcie dodane do galerii.',
  'gal.smazano': 'Zdjęcie usunięte',
  'gal.hesloKratke': 'Hasło galerii musi mieć co najmniej 4 znaki',
  'gal.nahraniChyba': 'Nie udało się wgrać zdjęcia',
  'gal.mazaniChyba': 'Nie udało się usunąć zdjęcia',
  'gal.souborVelky': 'Plik jest za duży (maks. 5 MB)',
  'gal.ulozitNastaveni': 'Zapisz ustawienia',
  'gal.hesloPopis': 'Osoby odwiedzające będą musiały wpisać to hasło, żeby zobaczyć galerię.',
  'gal.pridat': 'Dodaj zdjęcie albo wideo',
  'gal.prazdna': 'Na razie nie ma zdjęć w galerii',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': 'Gdzie teraz jestem?',
  'cesta.popis': 'Podziel się swoim etapem tranzycji, jeśli chcesz — albo zostaw go dla siebie.',
  'cesta.soukroma': 'Twój etap jest prywatny',
  'cesta.viditelna': 'Twój etap widzą inne osoby',
  'cesta.jenTy': 'Twój etap widzisz tylko ty',
  'cesta.mohouNajit': 'Inne osoby mogą cię znaleźć przez „Znajdź osoby na podobnym etapie”',
  'cesta.poznamka': 'Notatka osobista',
  'cesta.volitelna': '(opcjonalnie)',
  'cesta.poznamkaPriklad': 'Cokolwiek, czym chcesz się podzielić albo co chcesz zapamiętać…',
  'cesta.najitPodobne': 'Znajdź osoby na podobnym etapie',
  'cesta.hledam': 'Szukam…',
  'cesta.ulozit': 'Zapisz moją drogę',
  'cesta.ulozeno': 'Twoja droga została zapisana.',
  'cesta.vyberteFazi': 'Wybierz etap',
  'cesta.chyba': 'Nie udało się zapisać',

  'pf.socialniSite': 'Media społecznościowe',
  'pf.avatarFoto': 'Awatar / zdjęcie profilowe',
  'pf.nahratProfilni': 'Wgraj zdjęcie profilowe',
  'pf.zrusitProfil': 'Usuń profil',
  'pf.nastaveniOznameni': 'Ustawienia powiadomień',
  'pf.nastaveniOznameniPopis': 'Wybierz, o czym chcesz dostawać powiadomienia.',
  'gal.overEmail': 'Żeby wgrywać zdjęcia, najpierw potwierdź swój e-mail.',
  'cesta.coMeCeka': 'Co mnie czeka',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'Wiadomości',
  'zpr.hledatUzivatele': 'Szukaj osoby…',
  'zpr.zadneKonverzace': 'Na razie nie ma rozmów',
  'zpr.vyhledejteVyse': 'Wyszukaj osobę powyżej',
  'zpr.vyberteKonverzaci': 'Wybierz rozmowę albo wyszukaj kogoś',
  'zpr.napisteZpravu': 'Napisz wiadomość…',
  'zpr.nahravam': 'Nagrywam…',
  'zpr.prilozitObrazek': 'Załącz obrazek',
  'zpr.hlasovaZprava': 'Wiadomość głosowa',
  'zpr.zastavitNahravani': 'Zatrzymaj nagrywanie',
  'zpr.obrazek': 'Obrazek',
  'zpr.overteEmail': 'Żeby wysyłać wiadomości, potwierdź swój e-mail.',
  'zpr.profil': 'Profil',

  // šifrování
  'zpr.sifrovanaZprava': 'Zaszyfrowana wiadomość',
  'zpr.odemkniNahore': 'Zaszyfrowana wiadomość — odblokuj wiadomości powyżej.',
  'zpr.nelzeOtevrit': 'Nie udało się otworzyć tej zaszyfrowanej wiadomości.',

  // hlášky
  'zpr.uzivatelNenalezen': 'Nie znaleziono takiej osoby',
  'zpr.prijemceNenalezen': 'Nie znaleziono odbiorczyni',
  'zpr.prihlasteZnovu': 'Zaloguj się jeszcze raz (sesja wygasła)',
  'zpr.serverNedostupny': 'Serwer jest nieosiągalny. Sprawdź, czy backend działa.',
  'zpr.chybaOdeslani': 'Nie udało się wysłać',
  'zpr.souborVelky': 'Plik jest za duży (maks. 5 MB)',
  'zpr.formatNepodporovan': 'Nieobsługiwany typ pliku',
  'zpr.mediaOdeslano': 'Plik wysłany',
  'zpr.mikrofon': 'Mikrofon jest niedostępny',
  'zpr.hlasovkaOdeslana': 'Wiadomość głosowa wysłana',
  'zpr.hlasovkaChyba': (p) => `Nie udało się wysłać wiadomości głosowej: ${p.detail}`,
  'zpr.smazano': 'Rozmowa usunięta',
  'zpr.smazaniChyba': 'Nie udało się usunąć rozmowy',
  'zpr.smazaniPotvrzeni': 'Znika z twojej listy, razem z załącznikami. Druga osoba zachowuje swoją kopię — '
      + 'z serwera wiadomość znika całkiem dopiero wtedy, gdy usuniecie ją obie.',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'Wpisz swoje hasło.',
  'sif.zapnuto': 'Szyfrowanie jest włączone.',
  'sif.odemceno': 'Twoje wiadomości są odblokowane.',
  'sif.hesloNesedi': 'To hasło się nie zgadza.',
  'sif.prohlizecNeumi': 'Ta przeglądarka nie obsługuje szyfrowania, którego używa Bloom. Nadal możesz pisać, '
      + 'ale wiadomości nie będą szyfrowane od końca do końca.',
  'sif.noveJsouSifrovane': 'Nowe wiadomości są szyfrowane. Klucz masz tylko ty — serwer ich nie odczyta.',
  'sif.odemkniZpravy': 'Odblokuj swoje wiadomości',
  'sif.odemkniPopis': 'Klucz żyje tylko w pamięci tej karty, więc po odświeżeniu strony hasło jest potrzebne znowu. '
      + 'Nie możemy go nigdzie przechować — wtedy nie byłoby to już szyfrowanie, które kontrolujesz tylko ty.',
  'sif.zapniSifrovani': 'Włącz szyfrowanie wiadomości',
  'sif.zapniPopis': 'Nowe wiadomości są szyfrowane tu, na twoim urządzeniu. Serwer dostaje tylko nieczytelne znaki '
      + 'i nie odczyta ich — nawet gdyby poprosił o to sąd.',
  'sif.pozorA': 'Uwaga: klucz otwiera twoje hasło.',
  'sif.pozorTucne': 'Jeśli je zapomnisz, nikt nie odczyta twoich zaszyfrowanych wiadomości',
  'sif.pozorB': ' — my też nie. O to właśnie chodzi, ale znaczy to, że potrzebujesz miejsca, gdzie je przechowasz.',
  'sif.mobilA': 'Włączenie zmienia też sposób logowania: twoje hasło w ogóle przestaje docierać do serwera, wysyłany jest tylko jego skrót.',
  'sif.mobilTucne': 'Starsza aplikacja mobilna Bloom nie zaloguje się wtedy na to konto',
  'sif.mobilB': ', dopóki jej nie zaktualizujemy. W przeglądarce wszystko działa dalej.',
  'sif.zapnoutSifrovani': 'Włącz szyfrowanie',
  'sif.odemknout': 'Odblokuj',
  'sif.tvojeHeslo': 'Twoje hasło do Bloom',
  'sif.prilohaZamcena': 'Zaszyfrowany załącznik — odblokuj wiadomości powyżej.',
  'sif.prilohaChyba': 'Nie udało się otworzyć załącznika.',
  'sif.priloha': 'Załącznik wiadomości',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'Twoje miejsce',
  'okoli.nastavtePolohu': 'Podaj, gdzie jesteś, żeby zobaczyć dopasowane wyniki',
  'okoli.vyberteVyse': 'Wybierz miejsce powyżej, żeby zobaczyć oferty i specjalist_ki w twojej okolicy',
  'okoli.zadniOdbornici': 'W tej okolicy nie ma jeszcze zarejestrowanych specjalist_ek',
  'okoli.zadneNabidky': 'W tej okolicy nie ma jeszcze ofert',
  'okoli.zadniClenove': 'W tej okolicy nie ma jeszcze nikogo ze społeczności',
  'okoli.vytvoritNabidku': 'Dodaj ofertę',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': 'Szukam:',
  'hled.vysledkyPro': 'Wyniki wyszukiwania:',
  'hled.nicPro': 'Nic nie znaleźliśmy dla:',
  'hled.nicZkuste': 'Nic nie znaleźliśmy. Spróbuj innego słowa.',
  'hled.zkratte': 'Spróbuj krótszej frazy albo innego słowa kluczowego.',
  'hled.zadejte': 'Napisz, czego szukasz, i naciśnij Enter',
  'hled.priklady': 'Na przykład: FFS, hormony, imię, lekarka, dokumenty, operacja…',
  'hled.uzivatele': 'Osoby',
  'hled.odbornici': 'Trans-friendly specjalist_ki',
  'hled.clanky': 'Pomoc prawna – artykuły',
  'hled.otazky': 'Pytania społeczności',
  'hled.nabidky': 'Oferty pomocy',
  'hled.prispevky': 'Wpisy',
  'hled.recenze': 'Opinie o specjalist_kach',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'Nie znaleziono takiej osoby',
  'up.oMne': 'O osobie',
  'up.clenOd': 'W Bloom od',
  'up.odznakSpravce': 'Administracja',
  'up.odznakPravnik': 'Prawni_czka',
  'up.odznakOdbornik': 'Zweryfikowana specjalist_ka',
  'up.odznakPravnikOvereny': 'Zweryfikowana prawni_czka',
  'up.odznakClen': 'Zweryfikowana osoba',
  'up.odznakPomocnik': 'Aktywna pomoc',
  'up.odznakDuveryhodny': 'Godna zaufania',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Wróć do Bloom',
  'kom.oProjektu': 'Bloom powstał jako bezpieczna przestrzeń społecznościowa dla osób trans w Czechach — miejsce, '
      + 'żeby dzielić się doświadczeniem, znaleźć wsparcie, dotrzeć do specjalist_ek i poznać innych. '
      + 'Projekt prowadzi społeczność, wolontaryjnie. Chodzi o dyskrecję, prywatność i wzajemną pomoc.',
  'kom.kontaktText': 'Masz pytania albo potrzebujesz pomocy? Odezwij się. Staramy się odpowiadać jak najszybciej.',
  'kom.respekt': 'Szanujemy się nawzajem',
  'kom.respektPopis': 'Zwracamy się do każdej osoby imieniem i zaimkami, których używa. Szanujemy różne drogi i doświadczenia — '
      + 'nie ma dobrego ani złego sposobu bycia osobą trans.',
  'kom.soukromi': 'Chronimy swoją prywatność nawzajem',
  'kom.soukromiPopis': 'To, co dzieje się w Bloom, zostaje w Bloom. Nie udostępniaj informacji o innych osobach bez '
      + 'ich zgody. Szanujemy anonimowość.',
  'kom.pomahame': 'Pomagamy sobie',
  'kom.pomahamePopis': 'Bloom jest o wzajemnym wsparciu. Dzielimy się doświadczeniem, pomagamy sobie i budujemy bezpieczną przestrzeń '
      + 'dla każdej osoby, która szuka kontaktu albo informacji.',
  'kom.obtezovani': 'Nie tolerujemy nękania',
  'kom.obtezovaniPopis': 'Nękanie, zastraszanie ani wrogie komentarze nie mają w Bloom miejsca. Jeśli coś jest dla ciebie nie w porządku, '
      + 'napisz do administracji.',
  'kom.spam': 'Bez spamu i reklam',
  'kom.spamPopis': 'Bloom nie jest targowiskiem. Nie publikuj niezamówionych reklam ani treści komercyjnych. '
      + 'Oferty i prośby są we Wzajemnej pomocy.',
  'kom.prostor': 'Przestrzeń dla każdego etapu',
  'kom.prostorPopis': 'Nie jesteś sama, w którymkolwiek punkcie swojej drogi jesteś. Witamy osoby, które dopiero myślą '
      + 'o tranzycji, są w jej trakcie i mają ją za sobą — i bierzemy każdą drogę taką, jaka jest.',
  'kom.dataPopis': 'Bloom zbiera tylko te dane, których platforma potrzebuje, żeby działać: twój e-mail, pseudonim i profil, '
      + 'który sama tworzysz.',
  'kom.dataTretiStrany': 'Twoje dane nie trafiają do stron trzecich. Platforma nie używa technologii śledzących ani sieci reklamowych.',
  'kom.dataSmazani': 'Masz prawo poprosić o usunięcie konta i wszystkich powiązanych danych. Napisz do administracji.',

  'okoli.podtitulek': 'Znajdź osoby ze społeczności, usługi i specjalist_ki w swojej okolicy',
  'okoli.cleneVOkoli': (p) => `Osoby ze społeczności w okolicy: ${p.misto}`,
  'okoli.nabidkyVOkoli': (p) => `Oferty pomocy w okolicy: ${p.misto}`,
  'okoli.odborniciVOkoli': (p) => `Specjalist_ki w okolicy: ${p.misto}`,
  'hled.zobrazitVice': 'Pokaż więcej',
  'kom.titulek': 'Zasady społeczności',
  'kom.podtitulek': 'Bezpieczna przestrzeń dla wszystkich',
  'kom.jakNahlasit': 'Jak zgłosić problem',
  'kom.jakNahlasitPopis': 'Jeśli trafisz na niewłaściwe zachowanie, masz dwie możliwości: przycisk „Zgłoś tę osobę” '
      + 'na jej profilu albo napisz do administracji.',
  'kom.duverne': 'Twoje zgłoszenie jest poufne.',
  'kom.ochranaSoukromi': 'Prywatność',
  'obecne.zpetKratce': 'Wróć',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'Na razie nikt inny ze społeczności nie pokazuje tego etapu publicznie.',
  'cesta.poznamkaFazePriklad': 'Cokolwiek, czym chcesz się podzielić albo co chcesz zapamiętać z tego etapu…',
  'pruvodce.fazeNenalezena': 'Nie znaleziono etapu',
  'pruvodce.pripravujeme': 'Tę część jeszcze przygotowujemy.',
  'pruvodce.krokyJenTy': 'Odhaczone kroki widzisz tylko ty.',
  'pruvodce.nastavitFazi': 'Ustaw jako mój obecny etap',
  'pruvodce.fazeNastavena': 'Ustawione jako twój obecny etap',
  'pruvodce.chyba': 'Nie udało się zapisać, spróbuj jeszcze raz',
  'pruvodce.kroku': 'kroków',
  'pruvodce.odborniku': (p) => `${tvary('pl', p.pocet, { one: 'specjalist_ka', few: 'specjalist_ki', many: 'specjalist_ek', other: 'specjalist_ek' })} na ten etap`,
  'pruvodce.pribehu': (p) => `${tvary('pl', p.pocet, { one: 'historia', few: 'historie', many: 'historii', other: 'historii' })} osób na tym etapie`,

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'Reset hasła',
  'reset.popis': 'Wpisz nowe hasło do swojego konta Bloom.',
  'reset.noveHeslo': 'Nowe hasło',
  'reset.noveHesloPriklad': 'Wpisz nowe hasło',
  'reset.potvrdit': 'Potwierdź nowe hasło',
  'reset.nastavit': 'Zapisz nowe hasło',
  'reset.ukladam': 'Zapisuję…',
  'reset.hotovo': 'Hasło zostało zmienione. Możesz się zalogować.',
  'reset.neplatnyOdkaz': 'Ten link do resetu hasła nie jest ważny.',
  'reset.odkazVyprsel': 'Link wygasł albo jest nieważny. Poproś o nowy.',
  'reset.chyba': 'Nie udało się zresetować hasła.',
  'reset.neshoda': 'Hasła nie są takie same.',
  'reset.ztratiPristup': 'straci dostęp',

  'cesta.volitelne': 'To jest całkiem dobrowolne. Podziel się swoim etapem tranzycji, jeśli chcesz — albo zostaw go dla siebie. '
      + 'Możesz też znaleźć osoby w podobnym punkcie drogi.',
  'cesta.hledatVeFazi': 'Znajdź osoby na tym etapie:',
  'cesta.jenVerejne': '(tylko te, które pokazują to publicznie)',
  'pruvodce.zpetNaCestu': 'Wróć do Mojej drogi',
  'pruvodce.tadyJsi': 'Tu teraz jesteś',
  'reset.prejitNaPrihlaseni': 'Przejdź do logowania',
  'reset.sifrovaniVarovani': 'Jeśli masz włączone szyfrowanie wiadomości: po resecie hasła nie dostaniesz się już do starych '
      + 'zaszyfrowanych wiadomości. Ich klucz otwiera pierwotne hasło, którego nikt tu nie zna, więc nie da się go '
      + 'przepakować. Nowe wiadomości nadal będą szyfrowane; starych nikt nie odczyta — my też nie.',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'Zaloguj się',
  'uvod.vytvoritUcet': 'Załóż konto',
  'uvod.uzMamUcet': 'Mam już konto',
  'uvod.nadpis': 'Bezpieczna przestrzeń dla społeczności trans',
  'uvod.podnadpis': 'Bloom to prywatne miejsce, gdzie możesz mówić otwarcie, znaleźć trans-friendly specjalist_ki '
      + 'i przejść tranzycję wśród ludzi, którzy wiedzą, jak to jest.',
  'uvod.zdarma': 'Rejestracja jest darmowa. Treści Bloom otwierają się dopiero po zalogowaniu.',
  'uvod.kCemuJe': 'Po co jest Bloom',
  'uvod.kCemuJe1': 'Szukanie informacji o tranzycji w Czechach to zwykle przeklikiwanie się przez rozproszone '
      + 'fora, przestarzałe artykuły i linki, przy których nie wiadomo, komu ufać. A na wiele pytań '
      + 'i tak najlepiej odpowie ktoś, kto sam przez to przeszedł.',
  'uvod.kCemuJe2': 'Bloom zbiera to wszystko w jednym miejscu: specjalist_ki, z którymi społeczność ma dobre doświadczenia, przewodnik '
      + 'po etapach tranzycji, pomoc prawną, a przede wszystkim ludzi, do których można napisać.',
  'uvod.kCemuJe3': 'A ponieważ chodzi o rzeczy, o których nikt nie chce opowiadać całemu internetowi, Bloom jest od '
      + 'początku zbudowany tak, żeby z zewnątrz nie było widać zupełnie nic.',
  'uvod.coNajdes': 'Co znajdziesz w Bloom',
  'uvod.coNajdesPopis': 'Osiem części, które się uzupełniają — od praktycznej pomocy po wspólne doświadczenia.',
  'uvod.soukromiZaklad': 'Prywatność to nie dodatek, tylko podstawa',
  'uvod.jakZabezpeceny': 'Jak Bloom jest zabezpieczony',
  'uvod.zabezpeceniPopis': 'Danych osób nigdzie się nie sprzedaje ani nie analizuje. W Bloom nie działa żadne śledzenie '
      + 'reklamowe ani analityczne — żaden obcy skrypt niczego się o tobie nie dowie.',
  'uvod.coNeumi': 'Czego Bloom nie potrafi',
  'uvod.metadataTucne': 'kto do kogo i kiedy napisał',
  'uvod.coNeumiA': 'Serwer zawsze wie,',
  'uvod.coNeumiB': ' — bez tego nie dostarczyłby wiadomości. Tych metadanych nie ukryje ani szyfrowanie od końca do końca, '
      + 'ani Signal. Profili nie da się zaszyfrować, bo serwer musi je pokazać innym. '
      + 'A ponieważ Bloom jest aplikacją internetową, przy każdym otwarciu pobiera kod szyfrujący z naszego serwera '
      + '— kto przejąłby serwer, mógłby teoretycznie podsunąć zmieniony. '
      + 'Chroni przed tym tylko podpisana aplikacja ze sklepu.',
  'uvod.pridejSe': 'Dołącz',
  'uvod.pridejSePopis': 'Wystarczy pseudonim i e-mail — nigdzie nie musisz podawać imienia z dokumentów. To, co o sobie '
      + 'napiszesz, zależy od ciebie i możesz to zmienić albo usunąć kiedy chcesz.',

  // co Bloom nabízí
  'uvod.karta.podpora': 'Zaproponuj pomoc albo o nią poproś — od towarzyszenia u lekarki, przez pożyczenie ubrań, po '
      + '„muszę z kimś pogadać”.',
  'uvod.karta.odbornici': 'Seksuologia, endokrynologia, chirurgia, psychoterapia, a nawet fryzjerstwo. Z mapą, kontaktami i doświadczeniami innych.',
  'uvod.karta.pravo': 'Zmiana imienia, dokumenty, praca, szkoła. Odpowiadają osoby, które się na tym znają.',
  'uvod.karta.pruvodce': 'Co cię czeka na kolejnych krokach — od pierwszych pytań po operacje. Z linkami do sprawdzonych źródeł i specjalist_ek.',
  'uvod.karta.zpravy': 'Napisz do dowolnej osoby ze społeczności. Wiadomości i załączniki leżą na serwerze zaszyfrowane.',
  'uvod.karta.zkusenosti': 'Prawdziwe historie osób, które przez to przeszły. Bez cenzury i bez upiększania.',
  'uvod.karta.aktuality': 'Co dzieje się wokół tematów trans w Czechach — zmiany prawa, wydarzenia, nowości ze społeczności.',
  'uvod.karta.okoli': 'Kto jest blisko ciebie. Żebyś wiedziała, że nie jesteś sama, nawet w mniejszym mieście.',

  // zabezpečení
  'uvod.bezp.zvencinic': 'Z zewnątrz nie widać zupełnie nic',
  'uvod.bezp.zvencinicText': 'Profile, historie, zdjęcia, oferty i obrazki we wpisach wymagają zalogowania. Bez konta '
      + 'serwer nie wyda żadnej informacji o osobach — nawet wyszukiwarkom.',
  'uvod.bezp.hesla': 'Nikt nie zna twojego hasła',
  'uvod.bezp.heslaText': 'Zapisywany jest tylko skrót bcrypt, z którego nie da się wyliczyć pierwotnego hasła. Nawet '
      + 'administracja nie widzi twojego hasła i nie może ci go wysłać — może tylko pozwolić ci ustawić nowe.',
  'uvod.bezp.sifrovani': 'Wiadomości szyfrowane od ciebie do niej',
  'uvod.bezp.sifrovaniText': 'Gdy włączysz szyfrowanie od końca do końca, tekst i załączniki są szyfrowane w twojej własnej przeglądarce. '
      + 'Klucz otwiera twoje hasło i nigdy nie opuszcza twojego urządzenia — serwer dostaje tylko '
      + 'nieczytelne znaki i nie odczyta ich, nawet gdyby poprosił o to sąd. Bez szyfrowania wiadomości są przynajmniej '
      + 'zaszyfrowane na dysku serwera.',
  'uvod.bezp.kontakty': 'Twoje kontakty zostają u ciebie',
  'uvod.bezp.kontaktyText': 'E-mail ani telefon nigdy nie trafiają do innych osób. Twój etap tranzycji jest prywatny, dopóki '
      + 'sama go nie opublikujesz — a kroki odhaczone w Przewodniku widzisz tylko ty.',
  'uvod.bezp.smazane': 'Usunięte znaczy naprawdę usunięte',
  'uvod.bezp.smazaneText': 'Rozmowę możesz usunąć kiedy chcesz. Gdy usuną ją obie strony, znika z serwera na zawsze, '
      + 'razem z załącznikami.',
  'uvod.bezp.server': 'Własny serwer w Europie',
  'uvod.bezp.serverText': 'Bloom działa na własnym serwerze w Unii Europejskiej, wyłącznie przez HTTPS. Baza danych nie jest '
      + 'dostępna z internetu. Kopie zapasowe wychodzą zaszyfrowane na inne miejsce, a ich odtworzenie jest przetestowane.',

  'uvod.karta.pruvodceNazev': 'Przewodnik po tranzycji',
  'uvod.karta.zpravyNazev': 'Wiadomości prywatne',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': 'Zaproponuj to, co umiesz, i przyjmij pomoc od innych osób ze społeczności',
  'pod.vse': 'Wszystko',
  'pod.nabidky': 'Oferty',
  'pod.poptavky': 'Prośby',
  'pod.nabidka': 'Oferta',
  'pod.poptavka': 'Prośba',
  'pod.celaCR': 'Całe Czechy',
  'pod.celySvet': 'Cały świat',
  'pod.cesko': 'Czechy',
  'pod.svet': 'Świat',
  'pod.vsechnyTypy': 'Wszystkie kategorie',
  'pod.moje': (p) => `Moje (${p.pocet})`,
  'pod.pridat': 'Dodaj',
  'pod.overEmail': 'Potwierdź e-mail, żeby dodać ofertę',
  'pod.novaPoptavka': 'Nowa prośba',
  'pod.novaNabidka': 'Nowa oferta',
  'pod.popisPoptavky': 'Napisz, czego szukasz i co oferujesz w zamian.',
  'pod.popisNabidky': 'Zaproponuj to, co umiesz, innym osobom ze społeczności.',
  'pod.typPrispevku': 'Rodzaj wpisu',
  'pod.volitelne': '(opcjonalnie)',
  'pod.coNabizim': 'Co oferuję',
  'pod.coNabizimP': 'Co oferuję *',
  'pod.coHledamP': 'Czego szukam *',
  'pod.coHledamVymenou': 'Czego szukam w zamian',
  'pod.priklOffer': 'np. gotowanie, fryzury, tłumaczenie…',
  'pod.priklNeed': 'np. masaż, fotografia…',
  'pod.poptavkaSeZobrazi': 'Twoja prośba pojawi się w zakładce Prośby.',
  'pod.nabidkaSeZobrazi': 'Jeśli to wypełnisz, twoja oferta pojawi się też w zakładce Prośby.',
  'pod.popis': 'Opis',
  'pod.popisPriklad': 'Dokładniejszy opis…',
  'pod.oblast': 'Obszar',
  'pod.lokalita': 'Miejsce',
  'pod.nechciUvadet': 'Wolę nie podawać',
  'pod.kategorie': 'Kategoria',
  'pod.ostatni': 'Inne',
  'pod.pridatPoptavku': 'Dodaj prośbę',
  'pod.pridatNabidku': 'Dodaj ofertę',
  'pod.odpovedetNaPrispevek': 'Odpowiedz na wpis',
  'pod.napisteAutorovi': 'Napisz prywatną wiadomość do osoby, która to dodała.',
  'pod.od': (p) => `Od: ${p.kdo}`,
  'pod.odeslatZpravu': 'Wyślij wiadomość',
  'pod.konceptOdpovedi': (p) => `Cześć! Zainteresowała mnie twoja ${p.co} „${p.nazev}”. `,
  'pod.konceptPoptavka': 'prośba',
  'pod.konceptNabidka': 'oferta',
  'pod.zadneMoje': 'Nie masz jeszcze wpisów',
  'pod.zadneNalezeny': 'Nie znaleziono wpisów',
  'pod.vytvortePrvni': 'Utwórz swoją pierwszą ofertę albo prośbę',
  'pod.zkusteFiltry': 'Spróbuj zmienić filtry albo dodaj nowy wpis',
  'pod.expirovano': 'Wygasła',
  'pod.hledam': 'Szukam',
  'pod.hledamCo': (p) => `Szukam: ${p.co}`,
  'pod.nabizimCo': (p) => `Oferuję: ${p.co}`,
  'pod.expirovala': 'Ta oferta wygasła. Napisz do administracji, żeby ją odnowić.',
  'pod.odpovedet': 'Odpowiedz',
  'pod.upravitPrispevek': 'Edytuj wpis',
  'pod.upravtePrispevek': 'Edytuj swoją ofertę albo prośbę.',
  'pod.nabizimP': 'Oferuję *',
  'pod.hledamPotrebuji': 'Szukam / potrzebuję',
  'pod.coNabizitePriklad': 'Co oferujesz…',
  'pod.coHledatePriklad': 'Czego szukasz…',
  'pod.ulozitZmeny': 'Zapisz zmiany',
  'pod.vytvorenoPoptavka': 'Prośba utworzona.',
  'pod.vytvorenoNabidka': 'Oferta utworzona.',
  'pod.chybaVytvorit': 'Nie udało się utworzyć wpisu',
  'pod.opravduSmazat': 'Usunąć tę ofertę?',
  'pod.smazano': 'Usunięto',
  'pod.chybaSmazat': 'Nie udało się usunąć',
  'pod.aktualizovano': 'Wpis zaktualizowany.',
  'pod.chybaUlozit': 'Nie udało się zapisać',
  'pod.zpravaOdeslana': 'Wiadomość wysłana.',
  'pod.chybaOdeslat': 'Nie udało się wysłać wiadomości',
  'obecne.hledatPriklad': 'Szukaj…',
  'obecne.upravit': 'Edytuj',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'Znajdź sprawdzone specjalist_ki, które pomogą ci na twojej drodze',
  'odb.hledatPriklad': 'Szukaj po nazwisku albo mieście…',
  'odb.vsechnyObory': 'Wszystkie dziedziny',
  'odb.radit': 'Sortuj:',
  'odb.vychozi': 'Domyślnie',
  'odb.nejvyssiHodnoceni': '★ Najwyżej oceniane',
  'odb.nejnizsiHodnoceni': '★ Najniżej oceniane',
  'odb.zadniNalezeni': 'Nie znaleziono specjalist_ek',
  'odb.zkusteFiltry': 'Spróbuj zmienić filtry',
  'odb.recenzi': (p) => tvary('pl', p.pocet, { one: 'opinia', few: 'opinie', many: 'opinii', other: 'opinii' }),
  'odb.dostupnyV': 'Dostępna w:',
  'odb.otevritVMapach': 'Otwórz w mapach',
  'odb.pridatRecenzi': 'Dodaj opinię',
  'odb.ohodnotte': 'Oceń swoje doświadczenie z tą osobą.',
  'odb.vaseHodnoceni': 'Twoja ocena *',
  'odb.popisZkusenosti': 'Opisz swoje doświadczenie',
  'odb.popisteZkusenost': 'Opisz swoje doświadczenie…',
  'odb.odeslatRecenzi': 'Wyślij opinię',
  'odb.recenze': (p) => `Opinie (${p.pocet})`,
  'odb.zadneRecenze': 'Na razie nie ma opinii. Bądź pierwsza.',
  'odb.vyberteOdbornika': 'Wybierz osobę, żeby zobaczyć szczegóły i mapę',
  'odb.pridatOdbornika': 'Dodaj specjalist_kę',
  'odb.pridejteOdbornika': 'Dodaj do listy nową zweryfikowaną specjalist_kę.',
  'odb.navrhnout': 'Zaproponuj specjalist_kę',
  'odb.navrhnetePopis': 'Zaproponuj specjalist_kę do zatwierdzenia przez administrację.',
  'odb.navrhVysvetleni': 'Twoja propozycja trafi do administracji. Po zatwierdzeniu pojawi się na liście.',
  'odb.overEmail': 'Potwierdź e-mail, żeby zaproponować specjalist_kę',
  'odb.jmeno': 'Imię i nazwisko *',
  'odb.kategorie': 'Kategoria *',
  'odb.popis': 'Opis',
  'odb.popisPriklad': 'Specjalizacja, doświadczenie…',
  'odb.adresa': 'Adres *',
  'odb.mesto': 'Miasto *',
  'odb.kraj': 'Region',
  'odb.vyber': 'Wybierz',
  'odb.stat': 'Kraj',
  'odb.cesko': 'Czechy',
  'odb.telefon': 'Telefon',
  'odb.web': 'Strona',
  'odb.odesilam': 'Wysyłam…',
  'odb.odeslatKeSchvaleni': 'Wyślij do zatwierdzenia',
  'odb.recenzePridana': 'Opinia dodana.',
  'odb.chybaRecenze': 'Nie udało się dodać opinii',
  'odb.odeslanKeSchvaleni': 'Propozycja została wysłana do zatwierdzenia.',
  'odb.chybaOdeslat': 'Nie udało się wysłać',
  'odb.pridan': 'Specjalist_ka dodana.',
  'odb.chybaPridat': 'Nie udało się dodać',
  'odb.polozitOtazku': 'Zadaj pytanie',
  'odb.novaOtazka': 'Nowe pytanie do specjalist_ek',
  'odb.naCoSeZeptat': 'O co chcesz zapytać specjalist_ki?',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'Informacje i wsparcie dla społeczności trans',
  'prav.zpetNaPoradnu': 'Wróć do Pomocy prawnej',
  'prav.clankyAPruvodci': 'Artykuły i poradniki',
  'prav.pridatClanek': 'Dodaj artykuł',
  'prav.novyClanek': 'Nowy artykuł',
  'prav.vytvorteClanek': 'Napisz nowy artykuł do części prawnej.',
  'prav.nazev': 'Tytuł *',
  'prav.kategorie': 'Kategoria',
  'prav.publikovatIhned': 'Opublikuj od razu',
  'prav.publikovano': 'Opublikowane',
  'prav.obsah': 'Treść *',
  'prav.obsahPriklad': 'Treść artykułu…',
  'prav.zadneClanky': 'Brak artykułów w tej kategorii',
  'prav.skryto': 'Ukryte',
  'prav.skryt': 'Ukryj',
  'prav.publikovat': 'Opublikuj',
  'prav.upravitClanek': 'Edytuj artykuł',
  'prav.upravteObsah': 'Edytuj treść tego artykułu.',
  'prav.clanekPridan': 'Artykuł dodany.',
  'prav.chybaPridat': 'Nie udało się dodać artykułu',
  'prav.clanekUpraven': 'Artykuł zaktualizowany.',
  'prav.opravduSmazat': 'Usunąć ten artykuł?',
  'prav.chybaStav': 'Nie udało się zmienić stanu',
  'prav.pridatOtazku': 'Dodaj pytanie',
  'prav.novaOtazka': 'Nowe pytanie',
  'prav.naCoSeZeptat': 'O co chcesz zapytać?',
  'obecne.vse': 'Wszystko',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'Nowości ze świata trans',
  'akt.prehratVideo': 'Odtwórz wideo',
  'akt.obrazekVClanku': 'Obrazek w artykule',
  'akt.clanekNenalezen': 'Nie znaleziono artykułu',
  'akt.zpetNaAktuality': 'Wróć do aktualności',
  'akt.autor': (p) => `Autorstwo: ${p.kdo}`,
  'akt.osobniPribeh': 'Osobista historia',
  'akt.upravitClanek': 'Edytuj artykuł',
  'akt.komentare': (p) => `Komentarze (${p.pocet})`,
  'akt.zadneKomentare': 'Na razie nie ma komentarzy. Bądź pierwsza.',
  'akt.pridatKomentar': 'Dodaj komentarz…',
  'akt.proKomentovaniOverte': 'Potwierdź e-mail, żeby komentować.',
  'akt.profil': 'Profil',
  'akt.prihlasteSeProKomentovani': 'Zaloguj się, żeby komentować.',
  'akt.upravteObsah': 'Edytuj treść tego artykułu.',
  'akt.nadpisP': 'Tytuł *',
  'akt.nadpis': 'Tytuł',
  'akt.obsahP': 'Treść *',
  'akt.textClanku': 'Tekst artykułu…',
  'akt.obrazekUrlNeboSoubor': 'Obrazek (adres albo plik)',
  'akt.videoUrlNeboSoubor': 'Wideo (adres albo plik)',
  'akt.ukladam': 'Zapisuję…',
  'akt.novaAktualita': 'Nowa aktualność',
  'akt.sdiletPribeh': 'Podziel się historią',
  'akt.vytvoritAktualitu': 'Napisz aktualność',
  'akt.sdiletZkusenost': 'Podziel się doświadczeniem',
  'akt.napisteAktualitu': 'Napisz nową aktualność dla społeczności.',
  'akt.podelteSe': 'Podziel się swoim doświadczeniem ze społecznością.',
  'akt.obrazek': 'Obrazek',
  'akt.nahratObrazek': 'Wgraj obrazek…',
  'akt.nahratVideo': 'Wgraj wideo…',
  'akt.neboUrl': 'albo adres:',
  'akt.textAktuality': 'Tekst aktualności…',
  'akt.sdilejtePribeh': 'Podziel się swoją historią albo doświadczeniem ze społecznością…',
  'akt.nahravam': 'Wgrywam…',
  'akt.publikovat': 'Opublikuj',
  'akt.zkusenostiTucne': 'Osobiste doświadczenia osób ze społeczności.',
  'akt.zkusenostiPopis': 'Ta część służy do dzielenia się życiowymi doświadczeniami i historiami. Wpisy mogą zawierać tekst, obrazki albo wideo.',
  'akt.sdiletSvujPribeh': 'Podziel się swoją historią',
  'akt.zadneAktuality': 'Brak aktualności',
  'akt.zadneVKategorii': 'W tej kategorii na razie nic nie ma',
  'akt.publikovan': 'Wpis opublikowany.',
  'akt.chybaPublikovat': 'Nie udało się opublikować',
  'akt.opravduSmazat': 'Usunąć ten wpis?',
  'akt.chyba': 'Coś poszło nie tak',
  'akt.chybaKomentar': 'Nie udało się dodać komentarza',
  'akt.chybaSmazatKomentar': 'Nie udało się usunąć komentarza',
  'akt.aktualizovan': 'Wpis zaktualizowany.',
  'obecne.smazat': 'Usuń',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': 'Myślę o tranzycji',
  'faze.thinking.popis': 'Rozpoznaję, kim jestem i która droga jest moja.',
  'faze.research': 'Szukam informacji',
  'faze.research.popis': 'Czytam, pytam, szukam źródeł i społeczności.',
  'faze.therapist': 'Pierwsza wizyta u terapeut_ki',
  'faze.therapist.popis': 'Rozmawiam o swojej drodze ze specjalist_ką.',
  'faze.hormones': 'Terapia hormonalna',
  'faze.hormones.popis': 'Zaczynam albo kontynuuję terapię hormonalną.',
  'faze.documents': 'Zmiana dokumentów',
  'faze.documents.popis': 'Zajmuję się urzędową zmianą imienia albo oznaczenia płci.',
  'faze.cosmetic': 'Wygląd i pielęgnacja',
  'faze.cosmetic.popis': 'Pracuję nad swoim wyglądem – włosy, makijaż, styl.',
  'faze.surgery-thinking': 'Rozważam operacje',
  'faze.surgery-thinking.popis': 'Zastanawiam się nad możliwościami chirurgicznymi.',
  'faze.surgery': 'Po operacjach',
  'faze.surgery.popis': 'Mam za sobą jedną albo więcej operacji.',
  'faze.stable': 'Etap stabilny',
  'faze.stable.popis': 'Jestem tam, gdzie chcę być, i żyję swoim życiem.',
  'faze.individual': 'Moja własna droga',
  'faze.individual.popis': 'Moja droga nie pasuje do żadnej szufladki – i to jest w porządku.',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'Tu dzielimy się historiami.',
  'zk.pribehNenalezen': 'Nie znaleziono historii',
  'zk.zpetNaPribehy': 'Wróć do historii',
  'zk.komunita': 'Społeczność',
  'zk.pribeh': 'Historia',
  'zk.upravitPribeh': 'Edytuj historię',
  'zk.upravtePribeh': 'Edytuj historię, którą udostępniłaś.',
  'zk.textPribehu': 'Tekst historii…',
  'zk.fazeTranzice': 'Etap tranzycji',
  'zk.neuvadet': 'Nie podawać',
  'zk.ukazeSeLidem': 'Historia pokaże się osobom, które czytają przewodnik po tym etapie.',
  'zk.sdiletPribeh': 'Podziel się historią',
  'zk.overEmail': 'Potwierdź e-mail, żeby podzielić się historią',
  'zk.zadnePribehy': 'Na razie nie ma historii. Bądź pierwsza.',
  'zk.nazevPribehu': 'Tytuł twojej historii…',
  'zk.pribehP': 'Historia *',
  'zk.sdilejteZkusenost': 'Podziel się swoim doświadczeniem ze społecznością…',
  'zk.chybaNacist': 'Nie udało się wczytać historii',
  'zk.vyplnteNadpis': 'Wypełnij tytuł i tekst',
  'zk.spatnyOdkaz': 'Link do obrazka musi zaczynać się od http://, https:// albo /',
  'zk.sdilen': 'Historia udostępniona.',
  'zk.chybaSdilet': 'Nie udało się udostępnić',
  'zk.opravduSmazat': 'Usunąć tę historię?',
  'zk.smazan': 'Historia usunięta',
  'zk.aktualizovan': 'Historia zaktualizowana.',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'Twój e-mail nie jest jeszcze potwierdzony. Potwierdź go, proszę.',
  'ram.odesilam': 'Wysyłam…',
  'ram.znovuOdeslat': 'Wyślij ponownie',
  'ram.chceteUpozorneni': 'Chcesz dostawać powiadomienia o nowych wiadomościach?',
  'ram.tedNe': 'Teraz nie',
  'ram.paticka': '© 2026 Bloom – prywatna przestrzeń dla społeczności trans',
  'ram.zasadyKomunity': 'Zasady społeczności',
  'ram.prekladNeovereny': 'Tego tłumaczenia nie czytał jeszcze nikt, kto mówi tym językiem. Jeśli coś brzmi źle, daj nam znać.',
  'ram.nahlasitProblem': 'Zgłoś problem',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': 'Administracja',
  'ot.overenyPravnik': 'Zweryfikowana prawni_czka',
  'ot.overenyOdbornik': 'Zweryfikowana specjalist_ka',
  'ot.odznakJinaZeme': (p) => `Ta odznaka obowiązuje tylko w: ${p.zeme}`,
  'ot.otazkyKomunity': 'Pytania społeczności',
  'ot.pridatOtazku': 'Dodaj pytanie',
  'ot.novaOtazka': 'Nowe pytanie',
  'ot.naCoSeZeptat': 'O co chcesz zapytać?',
  'ot.otazkaSeZobrazi': 'Twoje pytanie zobaczą inne osoby ze społeczności, które mogą na nie odpowiedzieć.',
  'ot.otazkaP': 'Pytanie *',
  'ot.oblastTema': 'Obszar / temat',
  'ot.vseObecna': 'Cokolwiek (pytanie ogólne)',
  'ot.odeslatOtazku': 'Wyślij pytanie',
  'ot.overEmail': 'Potwierdź e-mail, żeby zadać pytanie',
  'ot.zadneOtazky': 'Na razie nie ma pytań. Bądź pierwsza.',
  'ot.hlasu': (p) => tvary('pl', p.pocet, { one: 'głos', few: 'głosy', many: 'głosów', other: 'głosów' }),
  'ot.odpovedi': (p) => tvary('pl', p.pocet, { one: 'odpowiedź', few: 'odpowiedzi', many: 'odpowiedzi', other: 'odpowiedzi' }),
  'ot.zadneOdpovedi': 'Na razie nie ma odpowiedzi.',
  'ot.napisteOdpoved': 'Napisz odpowiedź…',
  'ot.jenPravnici': 'Na pytania w Pomocy prawnej odpowiadają zweryfikowane prawni_czki i administracja.',
  'ot.smazatOtazku': 'Usunąć to pytanie?',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': 'Oferty i prośby',
  'cp.zadneNabidky': 'Brak ofert',
  'cp.napsatZpravu': 'Napisz wiadomość',
  'cp.nahlasitUzivatele': 'Zgłoś tę osobę',
  'cp.nahlasitKoho': (p) => `Zgłoś: ${p.kdo}`,
  'cp.popisteDuvod': 'Opisz, dlaczego zgłaszasz. Zgłoszenie zobaczy administracja.',
  'cp.zustaneteAnonymni': 'Zgłoszenie trafia do administracji. Ty zostajesz anonimowa.',
  'cp.duvodP': 'Powód *',
  'cp.vybertDuvod': 'Wybierz powód…',
  'cp.nevhodneChovani': 'Niewłaściwe zachowanie',
  'cp.falesnyProfil': 'Fałszywy profil',
  'cp.jinyProblem': 'Inny problem',
  'cp.popisVolitelny': 'Opis',
  'cp.volitelny': '(opcjonalnie)',
  'cp.popisteSituaci': 'Opisz sytuację dokładniej…',
  'cp.odeslatNahlaseni': 'Wyślij zgłoszenie',
  'cp.vyberteDuvodChyba': 'Wybierz powód zgłoszenia',
  'cp.nahlaseniOdeslano': 'Zgłoszenie trafiło do administracji',
  'cp.chybaNahlaseni': 'Nie udało się wysłać zgłoszenia',
  'gal.chranenoHeslem': 'Chroniona hasłem',
  'gal.soukromi': 'Prywatność',
  'gal.nahravam': 'Wgrywam…',
  'gal.pridatFotku': 'Dodaj zdjęcie',
  'gal.nastaveniSoukromi': 'Prywatność galerii',
  'gal.verejna': 'Publiczna',
  'gal.chranenaHeslem': 'Chroniona hasłem',
  'gal.nastaveniUlozeno': 'Ustawienia galerii zapisane',
  'gal.jeChranena': 'Ta galeria jest chroniona hasłem',
  'gal.zadneFotky': 'Na razie nie ma zdjęć. Dodaj pierwsze.',
  'gal.otagovat': 'Oznacz osobę',
  'gal.hledatUzivatele': 'Szukaj osoby…',
  'gal.odemcena': 'Galeria odblokowana',
  'gal.spatneHeslo': 'Złe hasło do galerii',
  'gal.fotkaNahrana': 'Zdjęcie wgrane.',
  'gal.chybaNahrat': 'Nie udało się wgrać zdjęcia',
  'gal.fotkaSmazana': 'Zdjęcie usunięte',
  'gal.jizOtagovan': 'Ta osoba jest już oznaczona',
  'gal.otagovan': (p) => `Oznaczona: ${p.kdo}`,
  'gal.chybaTag': 'Nie udało się dodać oznaczenia',
  'gal.soukromiGalerie': 'Prywatność galerii',
  'gal.verejnaGalerie': 'Galeria publiczna',

  'ram.povolit': 'Zezwól',
  'ram.oProjektu': 'O projekcie',
  'ram.kontakt': 'Kontakt',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': 'Mapa świata – kliknij kraj, żeby go otworzyć',
  'mapa.priblizit': 'Przybliż',
  'mapa.oddalit': 'Oddal',
  'mapa.celySvet': 'Wróć do całego świata',
  'mapa.chybaNacteni': 'Nie udało się wczytać mapy',
  'mapa.chybaZkusteSeznam': 'Nie udało się wczytać mapy. Spróbuj listy krajów niżej.',
  'mapa.teprveRoste': 'Bloom dopiero tu zaczyna',
  'mapa.napovedaDotyk': 'Przeciągnij, aby przesunąć mapę; przybliżysz dwoma palcami, dwukrotnym stuknięciem albo przyciskami. Nie musisz jej używać — niżej są wyszukiwarka i pełna lista krajów.',
  'obsah.specialists': (p) => tvary('pl', p.pocet, { one: 'specjalist_ka', few: 'specjalist_ki', many: 'specjalist_ek', other: 'specjalist_ek' }),
  'obsah.organizations': (p) => tvary('pl', p.pocet, { one: 'organizacja', few: 'organizacje', many: 'organizacji', other: 'organizacji' }),
  'obsah.events': (p) => tvary('pl', p.pocet, { one: 'wydarzenie', few: 'wydarzenia', many: 'wydarzeń', other: 'wydarzeń' }),
  'obsah.pageants': (p) => tvary('pl', p.pocet, { one: 'konkurs', few: 'konkursy', many: 'konkursów', other: 'konkursów' }),
  'obsah.resources': (p) => tvary('pl', p.pocet, { one: 'materiał', few: 'materiały', many: 'materiałów', other: 'materiałów' }),
  'obsah.zaznamu': (p) => `${p.pocet} ${tvary('pl', p.pocet, { one: 'wpis', few: 'wpisy', many: 'wpisów', other: 'wpisów' })}`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'Gdzie masz dom?',
  'domov.popis': 'Dzięki temu Bloom pokaże ci to, co masz blisko. Przeglądać możesz dowolny kraj — twojego '
      + 'kraju to nie zmieni. Nigdzie się tego nie publikuje i możesz to zmienić kiedy chcesz.',
  'domov.preskocit': 'Pomiń',
  'domov.najitZemi': 'Znajdź kraj…',
  'domov.nicNeodpovida': 'Nic nie pasuje. Spróbuj inaczej.',
  'domov.klikniDoMapy': 'Możesz też po prostu kliknąć kraj na mapie powyżej.',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': 'Wpis',
  'typ.users': 'Osoba',
  'typ.specialists': 'Specjalist_ka',
  'typ.services': 'Oferta',
  'typ.articles': 'Pomoc prawna',
  'typ.questions': 'Pytanie społeczności',
  'typ.reviews': 'Opinia o specjalist_ce',
  'nav.emailNeoveren': 'E-mail niepotwierdzony',
  'nav.neovereny': 'Niepotwierdzony',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': 'Coś nie działa',
  'chyba.navrh': 'Propozycja usprawnienia',
  'chyba.bezpecnost': 'Problem z bezpieczeństwem',
  'chyba.jiny': 'Coś innego',
  'chyba.vyberteTyp': 'Wybierz rodzaj problemu',
  'chyba.popisteProsim': 'Opisz problem',
  'chyba.odeslano': 'Zgłoszenie wysłane, dziękujemy!',
  'chyba.chybaOdeslat': 'Nie udało się wysłać zgłoszenia',
  'chyba.napisteNam': 'Napisz nam, co się stało — pomoże nam to naprawić.',
  'chyba.typProblemu': 'Rodzaj problemu',
  'chyba.popisProblemu': 'Co się stało',
  'chyba.popisPriklad': 'Opisz, co się stało, czego się spodziewałaś i co się stało zamiast tego…',
  'chyba.priloha': 'Automatycznie dołączamy: obecną stronę, godzinę i informacje o twojej przeglądarce.',
  'chyba.odeslatHlaseni': 'Wyślij zgłoszenie',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': 'Napisz treść…',
  'ed.tucne': 'Pogrubienie (Ctrl+B)',
  'ed.kurziva': 'Kursywa (Ctrl+I)',
  'ed.odrazky': 'Lista punktowana',
  'ed.vlozitOdkaz': 'Wstaw link',
  'ed.vlozitTabulku': 'Wstaw tabelę',
  'ed.radky': 'Wiersze',
  'ed.sloupce': 'Kolumny',
  'ed.vlozit': 'Wstaw',
  'ed.barva.cerna': 'Czarny',
  'ed.barva.seda': 'Szary',
  'ed.barva.fialova': 'Fioletowy',
  'ed.barva.ruzova': 'Różowy',
  'ed.barva.modra': 'Niebieski',
  'ed.barva.zelena': 'Zielony',
  'ed.barva.cervena': 'Czerwony',
  'ed.barva.oranzova': 'Pomarańczowy',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'Ten link potwierdzający nie jest ważny.',
  'over.hotovo': 'Twój e-mail jest potwierdzony.',
  'over.odkazVyprsel': 'Link potwierdzający jest nieważny albo wygasł.',
  'over.overuji': 'Potwierdzam e-mail…',
  'over.cekejte': 'Chwileczkę.',
  'over.overen': 'E-mail potwierdzony.',
  'over.plnyPristup': 'Masz teraz pełny dostęp do wszystkiego w Bloom.',
  'over.prejitNaBloom': 'Przejdź do Bloom',
  'over.selhalo': 'Potwierdzenie się nie udało',
  'over.zpetNaPrihlaseni': 'Wróć do logowania',
  'oauth.ucetNenalezen': 'Nie znaleziono konta',
  'oauth.neexistujeGoogle': 'Do tego konta Google nie ma konta w Bloom. Najpierw się zarejestruj.',
  'oauth.neexistujeFacebook': 'Do tego konta Facebook nie ma konta w Bloom. Najpierw się zarejestruj.',
  'oauth.registrovatGoogle': 'Zarejestruj się przez Google',
  'oauth.registrovatFacebook': 'Zarejestruj się przez Facebook',
  'oauth.prihlasujiGoogle': 'Logowanie przez Google…',
  'oauth.prihlasujiFacebook': 'Logowanie przez Facebook…',
  'oauth.facebookSelhalo': 'Logowanie przez Facebook się nie udało',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': 'Wczytywanie…',
  'obecne.nezadano': '— nie podano —',
  'obecne.neplatnaHodnota': 'Ta wartość nie jest prawidłowa.',
  'obecne.strankovani': 'Stronicowanie',
  'navrh.doplnteNazev': 'Uzupełnij nazwę.',
  'navrh.vyberteZemi': 'Wybierz kraj.',
  'navrh.doplnte': (p) => `Uzupełnij: ${p.co}.`,
  'kat.overenoZaznam': 'Sprawdzone, że wpis odpowiada rzeczywistości',
  'kat.prihlaskyDo': (p) => `Zgłoszenia do ${p.datum}`,

  'up.odznakAdmin': 'Admin',

  'profil.zalozkaProfil': 'Profil',
  'profil.zalozkaGalerie': 'Galeria',
  'pf.lokalita': 'Miejsce',

  'cesta.legendaBarev': 'Legenda kolorów',

  'hled.pocetVysledku': (p) => `(${p.pocet} ${tvary('pl', p.pocet, { one: 'wynik', few: 'wyniki', many: 'wyników', other: 'wyników' })})`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': 'Długie blond włosy',
  'avatar.fem-lavender': 'Fioletowe włosy',
  'avatar.fem-peach': 'Bob z grzywką',
  'avatar.fem-dark': 'Długie ciemne włosy',
  'avatar.fem-straight': 'Rude włosy',
  'avatar.fem-ponytail': 'Kucyk',
  'avatar.masc-blue': 'Krótkie blond włosy',
  'avatar.masc-teal': 'Rozwichrzone włosy',
  'avatar.masc-gray': 'Siwe włosy',
  'avatar.masc-short': 'Jeżyk',
  'avatar.nb-mint': 'Miętowe włosy',
  'avatar.nb-lilac': 'Kok na górze',
  'avatar.nb-curly': 'Krótkie loki',
  'avatar.nb-sage': 'Włosy do ramion',
  'avatar.nb-mohawk': 'Irokez',
  'avatar.nb-undercut': 'Undercut',
  'avatar.nb-shaved': 'Ogolona głowa',
  'avatar.nb-glasses': 'Okulary',
  'avatar.animal-cat': 'Kot',
  'avatar.animal-fox': 'Lis',
  'avatar.animal-rabbit': 'Królik',
  'avatar.sym-flower': 'Kwiat',
  'avatar.sym-butterfly': 'Motyl',
  'avatar.sym-star': 'Gwiazda',
  'avatar.custom': 'Wgraj własne zdjęcie',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'Wylogowaliśmy cię po chwili bezczynności.',
  'odhl.necinnostPopis': 'Bloom nie zostawia zalogowania, kiedy nikogo przy tym nie ma.',
  'odhl.zaChvili': 'Za chwilę cię wylogujemy',
  'odhl.zaChviliPopis': 'Dotknij ekranu albo klawiatury w dowolnej chwili i zostaniesz zalogowana.',

  'reg.avatarSymboly': 'Symbole',

  'avatar.fem-bun': 'Kok',
  'avatar.masc-navy': 'Pełna broda',
  'avatar.masc-brown': 'Przedziałek z boku',
  'avatar.masc-goatee': 'Bródka',
  'avatar.nb-freckles': 'Piegi',
  'avatar.animal-panda': 'Panda',
  'avatar.animal-owl': 'Sowa',
  'avatar.sym-rainbow': 'Tęcza',
  'avatar.sym-heart': 'Serce',
  'avatar.sym-lotus': 'Lotos (Bloom)',

  'reg.potvrditHeslo': 'Potwierdź hasło',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': 'Utwórz',
  'obecne.sdilet': 'Udostępnij',
  'obecne.opravneni': 'Uprawnienie',
  'obecne.pristupGalerie': 'Aby przesłać zdjęcie, potrzebujemy dostępu do galerii.',
  'obecne.vsechnyRegiony': 'Wszystkie regiony',
  'obecne.cesko': 'Czechy',
  'obecne.odbornici': 'Specjaliści',
  'obecne.zadnaZprava': 'Brak wiadomości',
  'ucet.vyplnteEmailHeslo': 'Podaj e-mail i hasło',
  'ucet.spatneUdaje': 'Nieprawidłowy e-mail lub hasło',
  'ucet.googleSelhalo': 'Logowanie przez Google nie powiodło się',
  'ucet.skrytHeslo': 'Ukryj hasło',
  'ucet.emailOveren': 'Twój e-mail został potwierdzony.',
  'ucet.emailPriklad': 'ty@email.pl',
  'ucet.overeniSelhalo': 'Weryfikacja nie powiodła się.',
  'ucet.overeniSelhaloZnovu': 'Weryfikacja nie powiodła się. Spróbuj ponownie.',
  'ucet.komunitniHesloPovinne': 'Hasło społeczności jest wymagane',
  'ucet.zadejteKomunitniHeslo': 'Wpisz hasło społeczności…',
  'ucet.komunitniHesloPopis': 'Bloom to prywatna przestrzeń. Hasło może przekazać ci ktoś ze społeczności.',
  'ucet.prezdivkaMin3': 'Nazwa musi mieć co najmniej 3 znaki',
  'ucet.vyplntePrezdivku': 'Podaj nazwę',
  'ucet.vasePrezdivka': 'Twoja nazwa',
  'ucet.profilNeulozen': 'Nie udało się zapisać profilu',
  'ucet.anoZrusitProfil': 'Tak, usuń mój profil',
  'heslo.min8': 'Hasło musi mieć co najmniej 8 znaków',
  'heslo.maleP': 'Hasło musi zawierać małą literę',
  'heslo.velkeP': 'Hasło musi zawierać wielką literę',
  'heslo.cislo': 'Hasło musi zawierać cyfrę',
  'heslo.specialni': 'Hasło musi zawierać znak specjalny',
  'heslo.specialniPriklad': 'Hasło musi zawierać znak specjalny (!@#$%)',
  'heslo.napoveda': 'Min. 8 znaków, wielka litera, cyfra, znak specjalny',
  'profil.oSobe': 'Krótko o sobie…',
  'profil.zajmenaOna': 'ona/jej',
  'profil.zajmenaJine': 'inne',
  'profil.doplnujiciText': 'Opcjonalny dodatkowy tekst…',
  'profil.prikladOboru': 'np. chirurgia plastyczna, prawo rodzinne…',
  'komunita.soukromiNadpis': 'Chronimy prywatność',
  'komunita.soukromiText': 'To, co dzieje się w Bloom, zostaje w Bloom.',
  'komunita.podporaText': 'Bloom opiera się na wzajemnym wsparciu.',
  'komunita.neniObchod': 'Bloom nie jest platformą handlową.',
  'komunita.zadneObtezovani': 'Nękanie w żadnej formie nie ma miejsca w Bloom.',
  'komunita.oslovovani': 'Zwracamy się do każdej osoby imieniem i zaimkami, których używa.',
  'komunita.jakakolivEtapa': 'Niezależnie od tego, gdzie jesteś na swojej drodze.',
  'prav.kategZdravi': 'Zdrowie',
  'prav.kategPravni': 'Prawne',
  'prav.kategSocialni': 'Społeczne',
  'ot.chybaOdpoved': 'Nie udało się wysłać odpowiedzi.',
  'ot.chybaOtazka': 'Nie udało się dodać pytania.',
  'zk.napisteKomentar': 'Napisz komentarz…',
  'zpr.chybaHlasova': 'Nie udało się wysłać wiadomości głosowej. Serwer:',
  'zpr.chybaObrazek': 'Nie udało się wysłać obrazu. Serwer:',
  'pod.nabizim': 'Oferuję',
  'pod.coHledate': 'Czego szukasz? (np. masaż, fotografia…)',
  'pod.coNabizite': 'Co oferujesz? (np. gotowanie, fryzury…)',
  'pod.lokalitaVolitelna': 'Lokalizacja (opcjonalnie)',
  'pod.podrobnejsiPopis': 'Dokładniejszy opis *',
  'pod.vyplnteHledate': 'Napisz, czego szukasz.',
  'pod.vyplnteNabizite': 'Napisz, co oferujesz.',
  'pod.vyplntePopis': 'Dodaj opis.',
  'pod.zadnePrispevky': 'Nie masz jeszcze wpisów. Utwórz ofertę lub prośbę.',
  'svet.vybratZemi': 'Wybierz kraj',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': 'Zadaj pytanie',
  'ot.nadpis': 'Pytania i odpowiedzi',
  'zk.pridat': 'Dodaj historię',
  'zk.novy': 'Nowa historia',
  'zk.smazat': 'Usuń historię',
  'zk.zadne': 'Nie ma jeszcze historii. Podziel się jako pierwsza osoba.',
  'akt.zadne': 'Brak nowości.',
  'nav.clanky': 'Artykuły',
  'ucet.emailOdeslan': 'E-mail wysłany',
  'ucet.komunitniHeslo': 'Hasło społeczności',
  'ucet.nemateUcet': 'Nie masz konta? Zarejestruj się',
  'ucet.muzetePrihlasit': 'Możesz się teraz zalogować.',
  'ucet.zapomenutePopis': 'Podaj e-mail, a wyślemy ci link do zresetowania hasła.',
  'profil.oMneVolitelne': 'O mnie (opcjonalnie)',
  'profil.prezdivka': 'Nazwa',
  'profil.telefonVolitelne': 'Telefon (opcjonalnie)',
  'cesta.poznamkaVolitelna': 'Osobista notatka (opcjonalnie)',
  'okoli.vyberteLokalitu': 'Wybierz lokalizację powyżej',
  'hled.nadpis': 'Wyszukiwanie',
  'hled.popis': 'Szukaj w całej aplikacji – osoby, artykuły, historie, recenzje…',
  'hled.min2': 'Wpisz co najmniej 2 znaki, aby wyszukać',
  'pod.vsechnySluzby': 'Wszystkie usługi',
  'domu.clenoveKomunity': 'Członkowie społeczności',
  'zpr.zadneKonverzaceHledat': 'Brak rozmów. Wyszukaj kogoś powyżej.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': 'on/jego',
  'reg.zajmenaOni': 'onu/jenu',
  'reg.zajmenaOno': 'ono/jego',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': 'Usuń zdjęcie',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'Ustaw hasło do galerii',
  'reg.min3znaky': 'Min. 3 znaki',
  'reg.zopakujteHeslo': 'Powtórz hasło',
  'hled.vBloom': 'Szukaj w Bloom…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'Edytuj profil',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': 'Wybierz region',
  'obecne.region': 'Region',
  'gal.heslemChranena': 'Chroniona hasłem',
  'gal.hesloGalerie': 'Hasło galerii',
  'reset.nastavitHeslo': 'Ustaw hasło',
  'reset.hesloObnoveno': 'Hasło zresetowane.',
  'profil.nenalezen': 'Nie znaleziono profilu',
  'obecne.nebo': 'lub',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': 'Otwórz aplikację z kodami i przepisz sześć cyfr dla Bloom. Zamiast tego możesz też wpisać jeden z kodów zapasowych.',
  'auth.sifrovaniNapoveda': 'Jeśli włączyłaś szyfrowanie wiadomości w przeglądarce, aplikacja nie zaloguje się jeszcze do tego konta. Skorzystaj z bloomapp.cz w przeglądarce.',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'Pokaż hasło',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'Usunąć to zdjęcie?',
  'dvf.zadejteKod': 'Wpisz kod z aplikacji',
  'sif.odemknoutAplikaci': 'Odblokuj aplikację',
  'profil.odeslatZnovu': 'Wyślij ponownie',
};

export default pl;
